window.wsCustomTiers = window.wsCustomTiers || {};

/**
 * wholesale-toggle.js
 */

(function () {
  'use strict';

  var STORAGE_KEY    = 'wholesale_enabled';
  var TOGGLE_BTN_ID  = 'ws-mode-wholesale';
  var STATUS_ID      = null;
  var CART_TIER_DISCOUNTS = [
    { min: 0,     pct: 0    },
    { min: 150,   pct: 0    },
    { min: 300,   pct: 0.04 },
    { min: 600,   pct: 0.04 },
    { min: 1200,  pct: 0.06 },
    { min: 5000,  pct: 0.10 },
    { min: 12000, pct: 0.12 }
  ];

  function getActiveCartDiscountPct(totalCents) {
    var dollars = totalCents / 100;
    var pct = 0;
    for (var i = 0; i < CART_TIER_DISCOUNTS.length; i++) {
      if (dollars >= CART_TIER_DISCOUNTS[i].min) pct = CART_TIER_DISCOUNTS[i].pct;
    }
    return pct;
  }
  var STATUS_ID      = null;
  var WRAPPER_ID     = 'wholesale-toggle-wrapper';
  var WHOLESALE_CODE = 'WHOLESALE';
  var WHOLESALE_CODE = 'WHOLESALE';
  var WHOLESALE_TIER_CODE = 'WHOLESALE-TIER';

  var wholesaleEnabled = sessionStorage.getItem(STORAGE_KEY) === 'true';
  if (window.wsCustomerDropship) {
    wholesaleEnabled = false;
    sessionStorage.setItem(STORAGE_KEY, 'false');
  } else if (window.wsCustomerWholesale) {
    wholesaleEnabled = true;
    sessionStorage.setItem(STORAGE_KEY, 'true');
  }
  var nativeFetch      = null;

  // ── Fetch missing variant wholesale prices from product JSON ─────────────────
  var _fetchingVariants = {};
  function ensureVariantPrices(variantId, productHandle, cb) {
    if (window.wholesaleVariantPrices && window.wholesaleVariantPrices[String(variantId)]) {
      cb(window.wholesaleVariantPrices[String(variantId)]);
      return;
    }
    if (_fetchingVariants[variantId]) {
      _fetchingVariants[variantId].push(cb);
      return;
    }
    _fetchingVariants[variantId] = [cb];
    var url = '/products/' + productHandle + '.js';
    (nativeFetch || window.fetch.bind(window))(url)
      .then(function(r) { return r.json(); })
      .then(function(product) {
        product.variants.forEach(function(v) {
          if (!window.wholesaleVariantPrices) window.wholesaleVariantPrices = {};
          var wsPrice = v.metafields && v.metafields['custom.wholesale_price_number']
            ? Math.round(parseFloat(v.metafields['custom.wholesale_price_number']) * 100)
            : null;
          if (!wsPrice) {
            wsPrice = product.metafields && product.metafields['custom.wholesale_price_number']
              ? Math.round(parseFloat(product.metafields['custom.wholesale_price_number']) * 100)
              : null;
          }
          if (wsPrice) {
            window.wholesaleVariantPrices[String(v.id)] = {
              regular: v.compare_at_price || v.price,
              wholesale: wsPrice
            };
          }
        });
        var cbs = _fetchingVariants[variantId] || [];
        delete _fetchingVariants[variantId];
        var result = window.wholesaleVariantPrices && window.wholesaleVariantPrices[String(variantId)];
        cbs.forEach(function(fn) { fn(result || null); });
      })
      .catch(function() {
        var cbs = _fetchingVariants[variantId] || [];
        delete _fetchingVariants[variantId];
        cbs.forEach(function(fn) { fn(null); });
      });
  }

  // ── Throttled cart fetcher — max one request per second ─────────────────────
  var _cartFetchTimer = null;
  var _cartFetchCallbacks = [];
  var _cartFetchLastResult = null;
  var _cartFetchLastTime = 0;
  function throttledCartFetch(cb) {
    var now = Date.now();
    if (_cartFetchLastResult && (now - _cartFetchLastTime) < 1000) {
      cb(_cartFetchLastResult);
      return;
    }
    _cartFetchCallbacks.push(cb);
    if (_cartFetchTimer) return;
    _cartFetchTimer = setTimeout(function() {
      _cartFetchTimer = null;
      var fetcher = nativeFetch || window.fetch.bind(window);
      fetcher('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          _cartFetchLastResult = cart;
          _cartFetchLastTime = Date.now();
          var cbs = _cartFetchCallbacks.splice(0);
          cbs.forEach(function(fn) { fn(cart); });
        })
        .catch(function() {
          _cartFetchCallbacks.splice(0);
        });
    }, 300);
  }
  var cartMutationPending = false;
  var lastWholesaleBlocked = false;
  var modalDismissed = false;
  var wholesaleCheckoutUnlocked = !wholesaleEnabled;
  var checkoutForceBlockUntil = 0;
  var checkoutGuardInterval = null;
  var retailReconcileTimer = null;


  var WS_PROGRESS_MINIMUM = 150;
  var WS_PROGRESS_TIERS = [
    { amount: 150,   label: 'Wholesale Minimum',       badge: 'MINIMUM'            },
    { amount: 300,   label: '4% off',                  badge: '4% OFF'             },
    { amount: 600,   label: '4% off + Free Shipping',  badge: '4% + FREE SHIP'  },
    { amount: 1200,  label: '6% off + Free Shipping',  badge: '6% + FREE SHIP'  },
    { amount: 5000,  label: '10% off + Free Shipping', badge: '10% + FREE SHIP' },
    { amount: 12000, label: '12% off + Free Shipping', badge: '12% + FREE SHIP' }
  ];

  // ── Money formatting ────────────────────────────────────────────────────────
  function formatMoney(cents) {
    var amount = (parseInt(cents, 10) / 100).toFixed(2);
    return '$' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }


  function formatDollars(dollars) {
    return '$' + dollars.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function getNextProgressTier(dollars) {
    for (var i = 0; i < WS_PROGRESS_TIERS.length; i++) {
      if (dollars < WS_PROGRESS_TIERS[i].amount) return { tier: WS_PROGRESS_TIERS[i], index: i };
    }
    return null;
  }

  function getCurrentProgressTier(dollars) {
    var current = null;
    for (var i = 0; i < WS_PROGRESS_TIERS.length; i++) {
      if (dollars >= WS_PROGRESS_TIERS[i].amount) current = WS_PROGRESS_TIERS[i];
    }
    return current;
  }

  function updateWholesaleProgressBar(totalCents) {
    if (typeof window.wsProgressBarUpdate === 'function') {
      window.wsProgressBarUpdate(totalCents);
      return;
    }
    var bar = document.getElementById('wholesale-progress-bar');
    if (!bar) return;
    var dollars = totalCents / 100;
    bar.style.display = (sessionStorage.getItem(STORAGE_KEY) === 'true' && dollars >= 150) ? 'block' : 'none';
  }

  function refreshWholesaleProgress(totalCents) {
    if (typeof totalCents === 'number') {
      updateWholesaleProgressBar(totalCents);
      return;
    }

    var fetcher = nativeFetch || window.fetch.bind(window);
    fetcher('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var total = 0;
        cart.items.forEach(function(item) {
          var prices = getDisplayPricesForItem(item, true);
          total += prices.linePrice;
        });
        updateWholesaleProgressBar(total);
      })
      .catch(function() { updateWholesaleProgressBar(0); });
  }

  function installWholesaleProgressBarSync() {
    var hasBar = document.getElementById('wholesale-progress-bar');
    if (!hasBar) return;

    window.wsUpdateProgress = refreshWholesaleProgress;
    refreshWholesaleProgress();
    document.addEventListener('cart:updated', refreshWholesaleProgress);
    document.addEventListener('cart:refresh', refreshWholesaleProgress);
    document.addEventListener('wholesale:toggled', refreshWholesaleProgress);
  }

  // ── Custom SKU quantity tier pricing ────────────────────────────────────────
  if (!window.wsCustomTiers) window.wsCustomTiers = {};
  var wsTierFetchPromises = {};

  function fetchCustomTiers(sku, productHandle) {
    if (window.wsCustomTiers[sku]) return Promise.resolve();
    if (wsTierFetchPromises[sku]) return wsTierFetchPromises[sku];
    wsTierFetchPromises[sku] = fetch('/products/' + productHandle + '.json')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var metafields = data.product && data.product.metafields;
        if (Array.isArray(metafields)) {
          for (var i = 0; i < metafields.length; i++) {
            var mf = metafields[i];
            if ((mf.namespace === 'wholesale' || mf.namespace === 'custom') && mf.key === 'quantity_tiers') {
              try {
                window.wsCustomTiers[sku] = JSON.parse(mf.value);
              } catch(e) {}
              break;
            }
          }
        }
        // If still not found, wsCustomTiers may already be populated
        // by wholesale-price.liquid on product/collection pages — that's fine.
      })
      .catch(function() {});
    return wsTierFetchPromises[sku];
  }

  function preloadCustomTiers(cartItems) {
    var promises = [];
    cartItems.forEach(function(item) {
      var sku = (item.sku || '').toUpperCase();
      if (sku.indexOf('CUSTOM') === 0 && item.handle && !window.wsCustomTiers[sku]) {
        promises.push(fetchCustomTiers(sku, item.handle));
      }
    });
    return Promise.all(promises);
  }

  function getCustomTierPriceCents(sku, totalQty) {
    var tiers = window.wsCustomTiers && window.wsCustomTiers[(sku || '').toUpperCase()];
    if (!tiers) return null;
    var keys = Object.keys(tiers).map(Number).sort(function(a,b){ return b-a; });
    for (var i = 0; i < keys.length; i++) {
      if (totalQty >= keys[i]) return Math.round(tiers[String(keys[i])] * 100);
    }
    return null;
  }

  function getCustomSkuTotals(cartItems) {
    var totals = {};
    cartItems.forEach(function(item) {
      var sku = (item.sku || '').toUpperCase();
      if (sku.indexOf('CUSTOM') === 0) totals[sku] = (totals[sku] || 0) + item.quantity;
    });
    return totals;
  }
  // ── DOM price helpers ───────────────────────────────────────────────────────
  function getWholesalePrice(wrapper) {
    return parseInt(wrapper.dataset.wholesalePrice || '0', 10);
  }

  function getRegularPrice(wrapper) {
    return parseInt(wrapper.dataset.regularPrice || '0', 10);
  }

  function getWholesalePriceForVariant(variantId) {
    var id = String(variantId);
    if (window.wholesaleVariantPrices && window.wholesaleVariantPrices[id]) {
      var p = window.wholesaleVariantPrices[id];
      if (p.wholesale) return p.wholesale;
    }
    var wrapper = document.querySelector('.wholesale-price-wrapper[data-variant-id="' + id + '"]');
    if (wrapper) return getWholesalePrice(wrapper);
    return null;
  }

  function getRegularPriceForVariant(variantId) {
    var id = String(variantId);
    if (window.wholesaleVariantPrices && window.wholesaleVariantPrices[id]) {
      var p = window.wholesaleVariantPrices[id];
      if (p.regular) return p.regular;
    }
    var wrapper = document.querySelector('.wholesale-price-wrapper[data-variant-id="' + id + '"]');
    if (wrapper) return getRegularPrice(wrapper);
    return null;
  }

  // ── Swap product page prices ────────────────────────────────────────────────
  function swapPrices(enable) {
    document.querySelectorAll('.wholesale-price-wrapper').forEach(function (wrapper) {
      var retail    = wrapper.querySelector('.wholesale-price--retail');
      var wholesale = wrapper.querySelector('.wholesale-price--wholesale');
      if (!retail || !wholesale) return;

      if (enable) {
        wholesale.textContent   = formatMoney(getWholesalePrice(wrapper));
        retail.style.display    = 'none';
        retail.setAttribute('aria-hidden', 'true');
        wholesale.style.display = '';
        wholesale.removeAttribute('aria-hidden');
        wholesale.style.color      = '#16a34a';
        wholesale.style.fontWeight = '700';
      } else {
        retail.textContent      = formatMoney(getRegularPrice(wrapper));
        retail.style.display    = '';
        retail.removeAttribute('aria-hidden');
        wholesale.style.display = 'none';
        wholesale.setAttribute('aria-hidden', 'true');
        wholesale.style.color      = '';
        wholesale.style.fontWeight = '';
      }
    });

  }

  function getDisplayPricesForItem(item, enable, skuTotals) {
    var sku = (item.sku || '').toUpperCase();
    var wsPrice = null;
    if (sku.indexOf('CUSTOM') === 0 && skuTotals) {
      wsPrice = getCustomTierPriceCents(sku, skuTotals[sku] || item.quantity);
    }
    // Check Zepto _pplr_cart_variant FIRST — it has the surcharge baked in
    // and must take priority over _wholesale_price which only has the base price
    if (!wsPrice && item.properties && item.properties['_pplr_cart_variant']) {
      try {
        var pplrFirst = JSON.parse(item.properties['_pplr_cart_variant']);
        var pplrFirstKey = Object.keys(pplrFirst)[0];
        var pplrFirstCents = Math.round(parseFloat(pplrFirst[pplrFirstKey][1]) * 100);
        var pplrFirstVp = window.wholesaleVariantPrices && window.wholesaleVariantPrices[pplrFirstKey];
        if (pplrFirstCents > 0 && pplrFirstVp && pplrFirstVp.regular && pplrFirstVp.wholesale) {
          var pplrFirstSurcharge = Math.max(0, pplrFirstCents - pplrFirstVp.regular);
          wsPrice = pplrFirstVp.wholesale + pplrFirstSurcharge;
        }
      } catch(e) {}
    }

    if (!wsPrice && item.properties && item.properties['_wholesale_price']) {
      wsPrice = parseInt(item.properties['_wholesale_price'], 10);
    }
    if (!wsPrice && window.wholesaleVariantPrices && window.wholesaleVariantPrices[String(item.variant_id)]) {
      wsPrice = window.wholesaleVariantPrices[String(item.variant_id)].wholesale;
    }

    // Zepto (PPLR) items use dynamic variant IDs that won't exist in
    // wholesaleVariantPrices, and _wholesale_price may not be patched yet
    // (patchPplrCartItems is async). Compute wholesale+surcharge inline so
    // the DOM reflects the correct price immediately on every toggle.
    if (!wsPrice && item.properties) {
      // Type A: _pplr_ref_variant — look up base wholesale via original variant
      if (item.properties['_pplr_ref_variant']) {
        try {
          var refParsed = JSON.parse(item.properties['_pplr_ref_variant']);
          var refKey = String(refParsed.variant_id || '');
          var refVp = window.wholesaleVariantPrices && window.wholesaleVariantPrices[refKey];
          if (refVp && refVp.regular && refVp.wholesale) {
            var refSurcharge = Math.max(0, item.original_price - refVp.regular);
            wsPrice = refVp.wholesale + refSurcharge;
          }
        } catch(e) {}
      }
      // Type B: _pplr_cart_variant — {variantId: [qty, "zetoPriceString"]}
      // Surcharge = Zepto retail cents - base regular price.
      if (!wsPrice && item.properties['_pplr_cart_variant']) {
        try {
          var cvParsed = JSON.parse(item.properties['_pplr_cart_variant']);
          var cvKey = Object.keys(cvParsed)[0];
          var cvZetoCents = Math.round(parseFloat(cvParsed[cvKey][1]) * 100);
          var cvVp = window.wholesaleVariantPrices && window.wholesaleVariantPrices[cvKey];
          if (cvZetoCents > 0 && cvVp && cvVp.regular && cvVp.wholesale) {
            var cvSurcharge = Math.max(0, cvZetoCents - cvVp.regular);
            wsPrice = cvVp.wholesale + cvSurcharge;
          }
        } catch(e) {}
      }
    }

    var unitPrice;
    if (enable) {
      unitPrice = wsPrice || item.original_price;
    } else {
      var regularPrice = getRegularPriceForVariant(item.variant_id);
      unitPrice = regularPrice || item.original_price;
    }

    return {
      unitPrice: unitPrice,
      linePrice: unitPrice * item.quantity
    };
  }

  function applyCartStateFromCart(cart, enable) {
    var total = 0;
    var skuTotals = getCustomSkuTotals(cart.items);

    // Pre-calculate full cart total first so discount tier is accurate
    var cartTotal = 0;
    cart.items.forEach(function(item) {
      var sku = (item.sku || '').toUpperCase();
      var wsPrice = null;
      if (sku.indexOf('CUSTOM') === 0 && window.wsCustomTiers && window.wsCustomTiers[sku]) {
        var tiers = window.wsCustomTiers[sku];
        var totalQty = skuTotals[sku] || item.quantity;
        var keys = Object.keys(tiers).map(Number).sort(function(a,b){ return b-a; });
        for (var i = 0; i < keys.length; i++) {
          if (totalQty >= keys[i]) { wsPrice = Math.round(tiers[String(keys[i])] * 100); break; }
        }
      }
      if (!wsPrice && item.properties && item.properties['_wholesale_price']) wsPrice = parseInt(item.properties['_wholesale_price'], 10);
      if (!wsPrice && window.wholesaleVariantPrices && window.wholesaleVariantPrices[String(item.variant_id)]) wsPrice = window.wholesaleVariantPrices[String(item.variant_id)].wholesale;
      // Zepto fallback: compute wholesale+surcharge from _pplr_ref_variant / _pplr_cart_variant
      if (!wsPrice && item.properties) {
        if (item.properties['_pplr_ref_variant']) {
          try {
            var _refP = JSON.parse(item.properties['_pplr_ref_variant']);
            var _refVp = window.wholesaleVariantPrices && window.wholesaleVariantPrices[String(_refP.variant_id || '')];
            if (_refVp && _refVp.regular && _refVp.wholesale) wsPrice = _refVp.wholesale + Math.max(0, item.original_price - _refVp.regular);
          } catch(e) {}
        }
        if (!wsPrice && item.properties['_pplr_cart_variant']) {
          try {
            var _cvP = JSON.parse(item.properties['_pplr_cart_variant']);
            var _cvK = Object.keys(_cvP)[0];
            var _cvC = Math.round(parseFloat(_cvP[_cvK][1]) * 100);
            var _cvVp = window.wholesaleVariantPrices && window.wholesaleVariantPrices[_cvK];
            if (_cvC > 0 && _cvVp && _cvVp.regular && _cvVp.wholesale) wsPrice = _cvVp.wholesale + Math.max(0, _cvC - _cvVp.regular);
          } catch(e) {}
        }
      }
      cartTotal += (wsPrice || item.original_price) * item.quantity;
    });
    var discountPct = getActiveCartDiscountPct(cartTotal);

    var usedRows = [];
    cart.items.forEach(function (item, index) {
      var allVariantRows = Array.from(document.querySelectorAll('.cart-item[data-variant-id="' + item.variant_id + '"]'));
      var row = allVariantRows.find(function(r) { return usedRows.indexOf(r) === -1; }) || null;
      if (row) usedRows.push(row);

      // Zepto creates dynamic variants — fall back to matching by _pplr_ref_variant
      // or _pplr_cart_variant which contain the original variant ID
      if (!row && item.properties) {
        var origVariantId = null;
        if (item.properties['_pplr_ref_variant']) {
          try { origVariantId = JSON.parse(item.properties['_pplr_ref_variant']).variant_id; } catch(e) {}
        }
        if (!origVariantId && item.properties['_pplr_cart_variant']) {
          try { origVariantId = Object.keys(JSON.parse(item.properties['_pplr_cart_variant']))[0]; } catch(e) {}
        }
        if (origVariantId) {
          var allMatchingRows = Array.from(document.querySelectorAll('.cart-item[data-variant-id="' + origVariantId + '"]'));
          row = allMatchingRows.find(function(r) { return usedRows.indexOf(r) === -1; }) || null;
          if (row) usedRows.push(row);
        }
      }
      // Skip in-flight Zepto items — _pplr_cart_variant not written yet, so we
      // have no reliable wholesale price. Don't overwrite DOM with retail price;
      // the patchPplrCartItems retry (3s) will correct it once Zepto finishes.
      var isZeptoInFlight = !!(item.properties && !item.properties['_pplr_cart_variant'] && !item.properties['_pplr_ref_variant'] && (item.properties['_pplr_preview'] || item.properties['Preview']));
      if (isZeptoInFlight) return;

      var prices = getDisplayPricesForItem(item, enable, skuTotals);
      if (!isNaN(prices.linePrice)) total += prices.linePrice;

      if (!row) return;

      var sku = (item.sku || '').toUpperCase();
      var displayPrice = (enable && discountPct > 0) ? Math.round(prices.unitPrice * (1 - discountPct)) : prices.unitPrice;

      var isZepto = !!(item.properties && (item.properties['_pplr_cart_variant'] || item.properties['_pplr_ref_variant']));
      if (!isZepto) {
        row.querySelectorAll('.price__current').forEach(function(el) {
          el.textContent = formatMoney(displayPrice);
          el.style.color = displayPrice < item.original_price ? '#4caf50' : '';
        });
      }

      var totalEl = row.querySelector('.cart-item__total .price__current') || row.querySelector('.cart-item__total.price .price__current');
      if (!totalEl) {
        var allPriceCurrent = row.querySelectorAll('.price__current');
        if (allPriceCurrent.length > 1) totalEl = allPriceCurrent[allPriceCurrent.length - 1];
      }
      if (totalEl) {
        totalEl.textContent = formatMoney(displayPrice * item.quantity);
        totalEl.style.color = displayPrice < item.original_price ? '#4caf50' : '';
      }
      // For Zepto items, also update unit price after a delay to let Zepto finish
      if (isZepto) {
        setTimeout(function() {
          var unitEls = row.querySelectorAll('.price__current');
          var unitEl = unitEls.length > 0 ? unitEls[0] : null;
          if (unitEl) {
            unitEl.textContent = formatMoney(displayPrice);
            unitEl.style.color = displayPrice < item.original_price ? '#4caf50' : '';
          }
          if (totalEl) {
            totalEl.textContent = formatMoney(displayPrice * item.quantity);
            totalEl.style.color = displayPrice < item.original_price ? '#4caf50' : '';
          }
        }, 1800);
      }
      var activeTierPct = getActiveCartDiscountPct(cartTotal);

      row.querySelectorAll('.price__was').forEach(function(el) {
        if (el.closest('.cart-item__total')) return;
        if (activeTierPct > 0) {
          el.textContent = formatMoney(prices.unitPrice);
          el.classList.add('ws-tier-was');
          el.style.display = 'inline';
          el.style.color = '';
        } else {
          el.classList.remove('ws-tier-was');
          el.style.display = 'none';
        }
      });

      var totalWasEl = row.querySelector('.cart-item__total dd .price__was');
      if (totalWasEl) {
        if (activeTierPct > 0) {
          totalWasEl.textContent = formatMoney(prices.linePrice);
          totalWasEl.classList.add('ws-tier-was');
          totalWasEl.style.display = 'inline';
        } else {
          totalWasEl.classList.remove('ws-tier-was');
          totalWasEl.style.display = 'none';
        }
      }

      row.querySelectorAll('.price__was').forEach(function(el) {
        if (el.textContent.trim() === '') return;
        if (activeTierPct > 0) {
          el.classList.add('ws-tier-was');
          el.style.display = 'inline';
        } else {
          el.classList.remove('ws-tier-was');
          el.style.display = 'none';
        }
      });
    });

    if (wholesaleEnabled) {
      var activeTierPct = (typeof cartTotal !== 'undefined') ? getActiveCartDiscountPct(cartTotal) : 0;
      document.querySelectorAll('.price__was').forEach(function(el) {
        if (el.textContent.trim() === '') return;
        if (activeTierPct > 0) {
          el.classList.add('ws-tier-was');
          el.style.display = 'inline';
        } else {
          el.classList.remove('ws-tier-was');
          el.style.display = 'none';
        }
      });
    }

    // Fix Zepto subtotal — watch for Zepto to finish then correct the line total
    var usedRows2 = [];
    cart.items.forEach(function(item) {
      if (!item.properties || (!item.properties['_pplr_cart_variant'] && !item.properties['Preview'])) return;
      var variantId = item.variant_id;
      try {
        if (item.properties['_pplr_cart_variant']) {
          variantId = Object.keys(JSON.parse(item.properties['_pplr_cart_variant']))[0];
        }
      } catch(e) {}
      var allRows = Array.from(document.querySelectorAll('.cart-item[data-variant-id="' + variantId + '"]'));
      var row = allRows.find(function(r) { return usedRows2.indexOf(r) === -1; }) || null;
      if (!row) {
        allRows = Array.from(document.querySelectorAll('.cart-item[data-variant-id="' + item.variant_id + '"]'));
        row = allRows.find(function(r) { return usedRows2.indexOf(r) === -1; }) || null;
      }
      if (!row) return;
      usedRows2.push(row);
      var els = row.querySelectorAll('.price__current');
      var subtotalEl = els.length > 1 ? els[els.length - 1] : null;
      if (!subtotalEl) return;
      var itemQty = item.quantity;
      var itemEnable = enable;
      var itemProps = item.properties;
      var itemOriginal = item.original_price;
      function updateSubtotal() {
        var unitPrice = itemOriginal;
        if (itemEnable) {
          // For Zepto items, compute wholesale+surcharge from _pplr_cart_variant
          if (itemProps['_pplr_cart_variant']) {
            try {
              var pplrD = JSON.parse(itemProps['_pplr_cart_variant']);
              var pplrK = Object.keys(pplrD)[0];
              var zetoCents = Math.round(parseFloat(pplrD[pplrK][1]) * 100);
              var baseVp = window.wholesaleVariantPrices && window.wholesaleVariantPrices[pplrK];
              if (baseVp && baseVp.regular && baseVp.wholesale && zetoCents > 0) {
                var surcharge = Math.max(0, zetoCents - baseVp.regular);
                unitPrice = baseVp.wholesale + surcharge;
              } else if (itemProps['_wholesale_price']) {
                // Fallback to _wholesale_price if wholesaleVariantPrices not loaded yet
                unitPrice = parseInt(itemProps['_wholesale_price'], 10);
              }
            } catch(e) {
              if (itemProps['_wholesale_price']) unitPrice = parseInt(itemProps['_wholesale_price'], 10);
            }
          } else if (itemProps['_wholesale_price']) {
            unitPrice = parseInt(itemProps['_wholesale_price'], 10);
          }
        } else if (itemProps['_pplr_cart_variant']) {
          try {
            var pplrD2 = JSON.parse(itemProps['_pplr_cart_variant']);
            var pplrK2 = Object.keys(pplrD2)[0];
            unitPrice = Math.round(parseFloat(pplrD2[pplrK2][1]) * 100);
          } catch(e) {}
        }
        var lineTotal = unitPrice * itemQty;
        subtotalEl.textContent = formatMoney(lineTotal);
        subtotalEl.style.color = itemEnable && unitPrice < itemOriginal ? '#4caf50' : '';
      }
      // Watch for Zepto to update the unit price, then fix the subtotal
      var observer = new MutationObserver(function() {
        observer.disconnect();
        setTimeout(updateSubtotal, 100);
      });
      var unitEl = els[0];
      if (unitEl) {
        observer.observe(unitEl, { childList: true, subtree: true, characterData: true });
      }
      // Also run immediately and after delays as fallback
      updateSubtotal();
      setTimeout(updateSubtotal, 1000);
      setTimeout(updateSubtotal, 2500);
    });

    var tierSavings = 0;
    if (enable && discountPct > 0) {
      cart.items.forEach(function(item) {
        var sku = (item.sku || '').toUpperCase();
        var wsPrice = null;
        if (sku.indexOf('CUSTOM') === 0 && window.wsCustomTiers && window.wsCustomTiers[sku]) {
          var tiers = window.wsCustomTiers[sku];
          var totalQty = skuTotals[sku] || item.quantity;
          var keys = Object.keys(tiers).map(Number).sort(function(a,b){ return b-a; });
          for (var i = 0; i < keys.length; i++) {
            if (totalQty >= keys[i]) { wsPrice = Math.round(tiers[String(keys[i])] * 100); break; }
          }
        }
        if (!wsPrice && item.properties && item.properties['_wholesale_price']) wsPrice = parseInt(item.properties['_wholesale_price'], 10);
        if (!wsPrice && window.wholesaleVariantPrices && window.wholesaleVariantPrices[String(item.variant_id)]) wsPrice = window.wholesaleVariantPrices[String(item.variant_id)].wholesale;
        if (wsPrice) tierSavings += Math.round(wsPrice * discountPct) * item.quantity;
      });
    }
    var displayTotal = enable ? (cartTotal - tierSavings) : total;
    updateCheckoutTotal(displayTotal);
    updateCartPageSubtotal(displayTotal);
    window.wsComputedTotal = cartTotal;
    window.wsDisplayTotal = displayTotal;
    window.wsDiscountPct = discountPct;
    updateSavingsBreakdown(cart, enable);
    if (total > 0) {
      updateMinimumEnforcement(total);
      if (wholesaleEnabled) checkTierUp(total);
    }
    if (window.wsUpdateProgress) window.wsUpdateProgress(total);
  }

  // ── Update cart prices using cart.js data ───────────────────────────────────
  var _cachedCart = null;

  // Pre-populate cache on page load
  if (sessionStorage.getItem('wholesale_enabled') === 'true') {
    var fetcher = nativeFetch || window.fetch.bind(window);
    fetcher('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        _cachedCart = cart;
      });
  }

  function applyTierPricesToCart() {
    var fetcher = nativeFetch || window.fetch.bind(window);
    var isWholesale = sessionStorage.getItem('wholesale_enabled') === 'true';

    // Always fetch fresh data — never use stale cache for PPLR items
    fetcher('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        _cachedCart = cart;
        var hasCustom = cart.items.some(function(item) {
          return (item.sku || '').toUpperCase().indexOf('CUSTOM') === 0;
        });
        var isWholesale = sessionStorage.getItem('wholesale_enabled') === 'true';
        if (!hasCustom && !isWholesale) return;
        return preloadCustomTiers(cart.items).then(function() {
          if (isWholesale) patchPplrCartItems(cart);
          applyCartStateFromCart(cart, isWholesale);
        });
      });
  }

  function updateSavingsBreakdown(cart, enable) {
    if (!enable) {
      ['ws-savings-breakdown', 'ws-savings-breakdown-drawer'].forEach(function(id) {
        var el = document.getElementById(id);
        if (el) el.remove();
      });
      return;
    }

    var TIERS = [
      { min: 0,     max: 299.99,   pct: 0  },
      { min: 300,   max: 599.99,   pct: 4  },
      { min: 600,   max: 1199.99,  pct: 4  },
      { min: 1200,  max: 4999.99,  pct: 6  },
      { min: 5000,  max: 11999.99, pct: 10 },
      { min: 12000, max: Infinity, pct: 12 }
    ];

    // Calculate savings
    var wholesaleSavings = 0;
    var tierSavings      = 0;
    var orderTotal       = 0;

    var skuTotals = getCustomSkuTotals(cart.items);
    cart.items.forEach(function(item) {
      var wsPrice = getDisplayPricesForItem(item, true, skuTotals);
      if (!wsPrice) return;
      orderTotal += wsPrice * item.quantity;
    });

    var tierPct = 0;
    for (var i = 0; i < TIERS.length; i++) {
      var dollars = orderTotal / 100;
      if (dollars >= TIERS[i].min && dollars <= TIERS[i].max) tierPct = TIERS[i].pct;
    }

    cart.items.forEach(function(item) {
      var retailPrice = item.original_price * item.quantity;
      var wsPrice = getDisplayPricesForItem(item, true, skuTotals);
      if (!wsPrice) return;

      var wsLinePrice   = wsPrice * item.quantity;
      var wsSave        = retailPrice - wsLinePrice;
      var tierSave      = Math.round(wsPrice * tierPct / 100) * item.quantity;

      wholesaleSavings += wsSave;
      tierSavings      += tierSave;
    });

    var totalSavings = wholesaleSavings + tierSavings;
    if (totalSavings <= 0) return;

    if (tierPct <= 0) return;

    var html = [
      '<div style="display:flex;justify-content:space-between;align-items:center;background:#f0fdf4;border:1px solid #bbf7d0;border-radius:8px;padding:8px 12px;margin-top:16px;margin-bottom:16px;">',
        '<div style="display:flex;align-items:center;gap:6px;">',
          '<span style="font-size:13px;">🎉</span>',
          '<span style="font-size:12px;color:#166534;font-weight:600;">' + tierPct + '% tier discount applied</span>',
        '</div>',
        '<span style="font-size:13px;font-weight:800;color:#16a34a;">-' + formatMoney(tierSavings) + '</span>',
      '</div>'
    ].join('');

    // Cart page — inject BEFORE subtotal
    var subtotalRow = document.querySelector('#cart-summary .flex.justify-between.items-center.mt-6');
    if (subtotalRow) {
      var existing = document.getElementById('ws-savings-breakdown');
      if (existing) {
        existing.innerHTML = html;
      } else {
        var div = document.createElement('div');
        div.id  = 'ws-savings-breakdown';
        subtotalRow.insertAdjacentElement('beforebegin', div);
        div.innerHTML = html;
      }
    }

    // Cart drawer — inject before checkout buttons
    var drawerTarget = document.querySelector('.cart-drawer__checkout-buttons, .cart-drawer__footer');
    if (drawerTarget) {
      var existingDrawer = document.getElementById('ws-savings-breakdown-drawer');
      if (existingDrawer) {
        existingDrawer.innerHTML = html;
      } else {
        var drawerDiv = document.createElement('div');
        drawerDiv.id    = 'ws-savings-breakdown-drawer';
        drawerDiv.style.cssText = 'padding:0 16px 10px;';
        drawerTarget.insertAdjacentElement('beforebegin', drawerDiv);
        drawerDiv.innerHTML = html;
      }
    }
  }

  function updateCheckoutTotal(cents) {
    if (!cents || isNaN(cents)) return;
    var formatted = formatMoney(cents);
    document.querySelectorAll('.cart-drawer__checkout-buttons button, .cart-drawer__checkout-buttons a').forEach(function (el) {
      // Write to the text node directly — NOT innerHTML — to avoid triggering
      // the theme's own MutationObservers which cause a re-render loop.
      var nodes = el.childNodes;
      for (var i = nodes.length - 1; i >= 0; i--) {
        if (nodes[i].nodeType === 3 && /\$[\d,]+\.\d{2}/.test(nodes[i].textContent)) {
          nodes[i].textContent = nodes[i].textContent.replace(/\$[\d,]+\.\d{2}/, formatted);
          return;
        }
      }
    });
  }

  function updateCartPageSubtotal(cents) {
    if (!cents || isNaN(cents)) return;
    var formatted = formatMoney(cents);
    var subtotal = document.querySelector('#cart-summary .flex.justify-between.items-center.mt-6 p.mb-0.h6');
    if (!subtotal) return;

    var current = subtotal.textContent || '';
    if (/\$[\d,]+\.\d{2}/.test(current)) {
      subtotal.textContent = current.replace(/\$[\d,]+\.\d{2}/, formatted);
    } else {
      subtotal.textContent = formatted;
    }
  }

  function applyRetailPricesToVisibleCart() {
    if (wholesaleEnabled) return;
    _cartFetchLastResult = null;
    throttledCartFetch(function(cart) {
      if (wholesaleEnabled) return;
        var total = 0;
        var usedRetailRows = [];
        cart.items.forEach(function(item) {
          // Use original_price from cart.js — works for all items including Zepto
          // dynamic variants whose IDs don't exist in wholesaleVariantPrices.
          var unitPrice = item.original_price;
          var isZepto = !!(item.properties && (item.properties['_pplr_cart_variant'] || item.properties['Preview'] || item.properties['_pplr_preview']));
          if (isZepto) {
            try {
              var pplrData = JSON.parse(item.properties['_pplr_cart_variant']);
              var pplrKey = Object.keys(pplrData)[0];
              var pplrPrice = Math.round(parseFloat(pplrData[pplrKey][1]) * 100);
              if (pplrPrice > 0) unitPrice = pplrPrice;
            } catch(e) {}
          }
          var linePrice = unitPrice * item.quantity;
          total += linePrice;

          // For Zepto items, update DOM with Zepto price directly
          if (isZepto) {
            var zetVariantId = item.variant_id;
            try {
              if (item.properties && item.properties['_pplr_cart_variant']) {
                var zetParsed = JSON.parse(item.properties['_pplr_cart_variant']);
                zetVariantId = Object.keys(zetParsed)[0];
              }
            } catch(e) {}
            var allZetoRows = Array.from(document.querySelectorAll('.cart-item[data-variant-id="' + zetVariantId + '"]'));
            var zetRow = allZetoRows.find(function(r) { return usedRetailRows.indexOf(r) === -1; }) || null;
            if (zetRow) {
              usedRetailRows.push(zetRow);
              zetRow.querySelectorAll('.price__current').forEach(function(el) {
                el.style.visibility = 'hidden';
              });
              setTimeout(function() {
                zetRow.querySelectorAll('.price__current').forEach(function(el) {
                  el.textContent = formatMoney(unitPrice);
                  el.style.color = '';
                  el.style.visibility = '';
                });
                zetRow.querySelectorAll('.price__was, .price__compare, s, del, .original-price').forEach(function(el) {
                  el.style.display = 'none';
                });
              }, 1500);
            }
            return;
          }

          // Find the DOM row — direct match first, then Zepto PPLR fallback
          var allRetailRows = Array.from(document.querySelectorAll('.cart-item[data-variant-id="' + item.variant_id + '"]'));
          var row = allRetailRows.find(function(r) { return usedRetailRows.indexOf(r) === -1; }) || null;
          if (!row && item.properties) {
            var origId = null;
            if (item.properties['_pplr_ref_variant']) {
              try { origId = JSON.parse(item.properties['_pplr_ref_variant']).variant_id; } catch(e) {}
            }
            if (!origId && item.properties['_pplr_cart_variant']) {
              try { origId = Object.keys(JSON.parse(item.properties['_pplr_cart_variant']))[0]; } catch(e) {}
            }
            if (origId) {
              var allOrigRows = Array.from(document.querySelectorAll('.cart-item[data-variant-id="' + origId + '"]'));
              row = allOrigRows.find(function(r) { return usedRetailRows.indexOf(r) === -1; }) || null;
            }
          }
          if (!row) return;
          usedRetailRows.push(row);

          row.querySelectorAll('.price__current').forEach(function(el) {
            el.textContent = formatMoney(unitPrice);
            el.style.color = '';
          });
          var totalEl = row.querySelector('.cart-item__total .price__current');
          if (totalEl) { totalEl.textContent = formatMoney(linePrice); totalEl.style.color = ''; }
          row.querySelectorAll('.price__was').forEach(function(el) { el.style.display = 'none'; });
          row.querySelectorAll('.discount').forEach(function(el) {
            var li = el.closest('li'); if (li) li.style.display = 'none';
          });
        });

        if (total > 0) {
          updateCheckoutTotal(total);
          updateCartPageSubtotal(total);
        }
    });
  }

  // ── Update checkout button href dynamically ─────────────────────────────────
  function updateCheckoutLink(enable) {
    var btn    = document.getElementById('cart-drawer-checkout-btn');
    var btnAnn = document.getElementById('ws-ann-checkout-btn');
    if (btn) {
      btn.setAttribute('href', '/checkout');
    }
    if (btnAnn) {
      btnAnn.dataset.href = '/checkout';
    }
  }

  // ── Sparks & Celebrations ───────────────────────────────────────────────────
  var SPARK_COLORS    = ['#f0c419', '#ffe566', '#ffffff', '#16a34a', '#4ade80', '#fbbf24'];
  var CONFETTI_COLORS = ['#f0c419', '#16a34a', '#3b82f6', '#ec4899', '#f97316', '#a855f7'];

  function fireSparks(originEl) {
    if (!originEl) return;
    var rect  = originEl.getBoundingClientRect();
    var ox    = rect.left + rect.width / 2;
    var oy    = rect.top  + rect.height / 2;
    var count = 18;
    for (var i = 0; i < count; i++) {
      (function(i) {
        setTimeout(function() {
          var spark = document.createElement('div');
          spark.className = 'ws-spark';
          var angle = (i / count) * 360;
          var dist  = 40 + Math.random() * 50;
          var tx    = Math.cos(angle * Math.PI / 180) * dist;
          var ty    = Math.sin(angle * Math.PI / 180) * dist - 20;
          var dur   = 0.5 + Math.random() * 0.4;
          spark.style.cssText = [
            'left:' + ox + 'px',
            'top:' + oy + 'px',
            'background:' + SPARK_COLORS[Math.floor(Math.random() * SPARK_COLORS.length)],
            '--tx:' + tx + 'px',
            '--ty:' + ty + 'px',
            '--dur:' + dur + 's'
          ].join(';');
          document.body.appendChild(spark);
          setTimeout(function() { spark.remove(); }, dur * 1000 + 100);
        }, i * 20);
      })(i);
    }
  }

  function fireConfetti(count) {
    count = count || 40;
    var cx = window.innerWidth / 2;
    var cy = window.innerHeight * 0.2;
    for (var i = 0; i < count; i++) {
      (function() {
        var piece   = document.createElement('div');
        piece.className = 'ws-confetti';
        var tx    = (Math.random() - 0.5) * window.innerWidth * 0.8;
        var ty    = 150 + Math.random() * 300;
        var rot   = (Math.random() - 0.5) * 720;
        var dur   = 0.8 + Math.random() * 0.8;
        var delay = Math.random() * 0.4;
        var size  = 5 + Math.random() * 8;
        var color = CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)];
        var isRect = Math.random() > 0.5;
        piece.style.cssText = [
          'left:' + (cx + (Math.random() - 0.5) * 200) + 'px',
          'top:' + cy + 'px',
          'width:' + size + 'px',
          'height:' + (isRect ? size * 0.4 : size) + 'px',
          'background:' + color,
          'border-radius:' + (isRect ? '2px' : '50%'),
          '--tx:' + tx + 'px',
          '--ty:' + ty + 'px',
          '--rot:' + rot + 'deg',
          '--dur:' + dur + 's',
          '--delay:' + delay + 's'
        ].join(';');
        document.body.appendChild(piece);
        setTimeout(function() { piece.remove(); }, (dur + delay) * 1000 + 100);
      })();
    }
  }

  var TIER_THRESHOLDS = [150, 300, 600, 1200, 5000, 12000];
  var TIER_NAMES = [
    'Wholesale pricing unlocked — minimum order met!',
    '4% discount applied to your entire order!',
    '4% off + Free Shipping unlocked — saving big!',
    '6% off + Free Shipping unlocked — you\'re a top buyer!',
    '10% off + Free Shipping — elite wholesale status reached!',
    '12% off + Free Shipping — maximum discount unlocked — best possible price!'
  ];
  var TIER_ICONS      = ['🎉', '✨', '🚀', '💎', '👑', '🏆'];
  var lastTierIndex   = -1;

  function checkTierUp(totalCents) {
    var dollars   = totalCents / 100;
    var tierIndex = -1;
    for (var i = 0; i < TIER_THRESHOLDS.length; i++) {
      if (dollars >= TIER_THRESHOLDS[i]) tierIndex = i;
    }
    if (tierIndex > lastTierIndex) {
      var toggleEl = document.getElementById('wholesale-toggle-btn');
      fireSparks(toggleEl);
      fireConfetti(50);
      showTierUpBanner(tierIndex);
    }
    lastTierIndex = tierIndex;
  }

  function showWholesaleLockedModal() {
    var existing = document.getElementById('ws-locked-modal');
    if (existing) return;

    var overlay = document.createElement('div');
    overlay.id = 'ws-locked-modal';
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:999999;display:flex;align-items:center;justify-content:center;padding:20px;backdrop-filter:blur(3px);';

    overlay.innerHTML = [
      '<div style="background:#fff;border:1px solid #f0f0f0;border-top:3px solid #f0c419;border-radius:14px;max-width:400px;width:100%;padding:32px 28px;text-align:center;box-shadow:0 20px 60px rgba(0,0,0,0.15);position:relative;">',
        '<button id="ws-locked-close-btn" style="position:absolute;top:14px;right:16px;background:none;border:none;color:#bbb;font-size:22px;cursor:pointer;line-height:1;">✕</button>',

        '<div style="text-align:center;margin-bottom:20px;">',
          '<img src="https://cdn.shopify.com/s/files/1/0861/1368/1687/files/SmartBlondeLogoTransparent_2.png?v=1719892102" alt="Smart Blonde" style="height:55px;width:auto;object-fit:contain;">',
        '</div>',

        '<h2 style="font-size:20px;font-weight:900;color:#1a1008;margin:0 0 8px;">Wholesale Pricing is Active</h2>',
        '<div style="width:260px;height:3px;background:#f0c419;border-radius:99px;margin:0 auto 16px;"></div>',

        '<p style="font-size:14px;color:#555;margin:0 0 24px;line-height:1.7;">',
          'Your account has <strong style="color:#1a1008;">wholesale pricing enabled</strong>. To switch to retail pricing you must sign out of your account first.',
        '</p>',

        '<div style="height:1px;background:#f0f0f0;margin-bottom:20px;"></div>',

        '<button id="ws-locked-signout-btn" style="display:block;width:100%;background:linear-gradient(180deg,#f7cd30 0%,#e8b800 100%);color:#1a1000;font-weight:800;font-size:14px;padding:14px;border-radius:8px;border:2px solid #c49a00;cursor:pointer;margin-bottom:10px;box-sizing:border-box;border-radius:8px;">',
          'Sign Out',
        '</button>',

        '<button id="ws-locked-dismiss-btn" style="display:block;width:100%;background:transparent;color:#888;font-size:13px;padding:10px;border-radius:8px;border:1px solid #eee;cursor:pointer;">',
          'Keep Wholesale Pricing',
        '</button>',

      '</div>'
    ].join('');

    document.body.appendChild(overlay);

    document.getElementById('ws-locked-close-btn').addEventListener('click', function() { overlay.remove(); });
    document.getElementById('ws-locked-dismiss-btn').addEventListener('click', function() { overlay.remove(); });
    document.getElementById('ws-locked-signout-btn').addEventListener('click', function() {
      sessionStorage.setItem('wholesale_enabled', 'false');
      sessionStorage.setItem('ws_just_signed_out', 'true');
      window.location.href = '/account/logout';
    });
    overlay.addEventListener('click', function(e) { if (e.target === overlay) overlay.remove(); });
  }

  window.showMinimumNotMetModal = showMinimumNotMetModal;
  function showMinimumNotMetModal() {
    var existing = document.getElementById('ws-minimum-modal');
    if (existing) return;

    nativeFetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var total = 0;
        var skuTotals = {};
        cart.items.forEach(function(item) {
          var sku = (item.sku || '').toUpperCase();
          if (sku.indexOf('CUSTOM') === 0) skuTotals[sku] = (skuTotals[sku] || 0) + item.quantity;
        });
        cart.items.forEach(function(item) {
          var sku = (item.sku || '').toUpperCase();
          var wsPrice = null;
          if (sku.indexOf('CUSTOM') === 0 && window.wsCustomTiers && window.wsCustomTiers[sku]) {
            var tiers = window.wsCustomTiers[sku];
            var totalQty = skuTotals[sku] || item.quantity;
            var keys = Object.keys(tiers).map(Number).sort(function(a,b){ return b-a; });
            for (var i = 0; i < keys.length; i++) {
              if (totalQty >= keys[i]) { wsPrice = Math.round(tiers[String(keys[i])] * 100); break; }
            }
          }
          if (!wsPrice && item.properties && item.properties['_wholesale_price']) wsPrice = parseInt(item.properties['_wholesale_price'], 10);
          if (!wsPrice && window.wholesaleVariantPrices && window.wholesaleVariantPrices[String(item.variant_id)]) wsPrice = window.wholesaleVariantPrices[String(item.variant_id)].wholesale;
          total += (wsPrice || item.original_price) * item.quantity;
        });

        var needed  = Math.max(15000 - total, 0);
        var dollars = total / 100;
        var pct     = Math.min((dollars / 150) * 100, 100);

        var overlay = document.createElement('div');
        overlay.id  = 'ws-minimum-modal';
        overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:999999;display:flex;align-items:center;justify-content:center;padding:20px;backdrop-filter:blur(3px);';

        overlay.innerHTML = [
          '<style>@keyframes ws-pulse-red{0%,100%{border-top-color:#b91c1c}50%{border-top-color:#ef4444}}</style>',
          '<div style="background:#fff;border:1px solid #f0f0f0;border-top:3px solid #b91c1c;border-radius:14px;max-width:400px;width:100%;padding:32px 28px;text-align:center;box-shadow:0 20px 60px rgba(0,0,0,0.15);position:relative;animation:ws-pulse-red 1.5s ease-in-out infinite;">',
            '<button id=\"ws-min-close-btn\" style=\"position:absolute;top:14px;right:16px;background:none;border:none;color:#bbb;font-size:22px;cursor:pointer;line-height:1;\">✕</button>',

            '<div style=\"text-align:center;margin-bottom:20px;\">',
              '<img src=\"https://cdn.shopify.com/s/files/1/0861/1368/1687/files/SmartBlondeLogoTransparent_2.png?v=1719892102\" alt=\"Smart Blonde\" style=\"height:55px;width:auto;object-fit:contain;\">',
            '</div>',

            '<h2 style=\"font-size:22px;font-weight:900;color:#1a1008;margin:0 0 8px;letter-spacing:-0.02em;\">Minimum Order Not Met</h2>',
            '<div style="width:280px;height:3px;background:#f0c419;border-radius:99px;margin:0 auto 16px;"></div>',

            '<p style="font-size:14px;color:#555;margin:0 0 24px;line-height:1.6;">',
              'Wholesale checkout requires a <strong style="color:#1a1008;">$150 minimum</strong>. ',
              'Add <strong style="color:#1a1008;">' + formatMoney(needed) + '</strong> more to unlock checkout.',
            '</p>',

            '<div style="height:1px;background:#f0f0f0;margin-bottom:20px;"></div>',

            '<button id="ws-min-shop-btn" style="display:block;width:100%;background:linear-gradient(180deg,#f7cd30 0%,#e8b800 100%);color:#1a1000;font-weight:800;font-size:14px;padding:14px;border-radius:8px;border:2px solid #c49a00;cursor:pointer;margin-bottom:10px;">',
              'Keep Shopping — Add ' + formatMoney(needed) + ' More',
            '</button>',

          '</div>'
        ].join('');

        document.body.appendChild(overlay);

        document.getElementById('ws-min-shop-btn').addEventListener('click', function() {
          overlay.remove();
          var drawerClose = document.querySelector('.cart-drawer__close, [data-close-drawer], .js-close-drawer');
          if (drawerClose) drawerClose.click();
        });

        var minCloseBtn = document.getElementById('ws-min-close-btn');
        if (minCloseBtn) {
          minCloseBtn.addEventListener('click', function() {
            overlay.remove();
          });
        }

        overlay.addEventListener('click', function(e) {
          if (e.target === overlay) overlay.remove();
        });

        overlay.addEventListener('click', function(e) {
          if (e.target === overlay) overlay.remove();
        });
      });
  }

  // ── Pre-checkout upsell modal ───────────────────────────────────────────────
  function showCheckoutUpsellModal(totalCents, onContinue) {
    var dollars   = totalCents / 100;
    var nextTier  = null;
    var nextTierName = '';
    var needed    = 0;
    var TIERS = [
      { amount: 150,  name: 'Wholesale Access',          saving: 'wholesale pricing'       },
      { amount: 300,  name: '4% off your entire order',  saving: '4% off'                  },
      { amount: 600,  name: '4% off + Free Shipping',    saving: '4% off + free shipping'  },
      { amount: 1200, name: '6% off + Free Shipping',    saving: '6% off + free shipping'  },
      { amount: 5000, name: '10% off + Free Shipping',   saving: '10% off + free shipping' },
      { amount: 12000,name: '12% off + Free Shipping',   saving: '12% off + free shipping' }
    ];
    for (var i = 0; i < TIERS.length; i++) {
      if (dollars < TIERS[i].amount) {
        nextTier     = TIERS[i];
        needed       = TIERS[i].amount - dollars;
        nextTierName = TIERS[i].name;
        break;
      }
    }

    // Only show if within 50% of the next tier
    if (!nextTier) {
      onContinue();
      return;
    }
    var prevAmount = 0;
    for (var j = 0; j < TIERS.length; j++) {
      if (TIERS[j].amount === nextTier.amount && j > 0) prevAmount = TIERS[j-1].amount;
    }
    var tierRange = nextTier.amount - prevAmount;
    var pctRemaining = needed / tierRange;
    if (pctRemaining > 0.5) {
      onContinue();
      return;
    }

    var savingsAmount = (dollars * (nextTier.amount === 300 ? 0.04 : nextTier.amount === 600 ? 0.04 : nextTier.amount === 1200 ? 0.06 : nextTier.amount === 5000 ? 0.10 : 0.12)).toFixed(2);

    var overlay = document.createElement('div');
    overlay.id  = 'ws-upsell-overlay';
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:999999;display:flex;align-items:center;justify-content:center;padding:20px;backdrop-filter:blur(3px);';

    overlay.innerHTML = [
      '<div style="background:#fff;border:1px solid #f0f0f0;border-top:3px solid #f0c419;border-radius:14px;max-width:400px;width:100%;padding:32px 28px;text-align:center;box-shadow:0 20px 60px rgba(0,0,0,0.15);position:relative;">',
            '<button id="ws-upsell-close-btn" style="position:absolute;top:14px;right:16px;background:none;border:none;color:#bbb;font-size:22px;cursor:pointer;line-height:1;">✕</button>',

        '<div style="text-align:center;margin-bottom:20px;">',
          '<img src="https://cdn.shopify.com/s/files/1/0861/1368/1687/files/SmartBlondeLogoTransparent_2.png?v=1719892102" alt="Smart Blonde" style="height:55px;width:auto;object-fit:contain;">',
        '</div>',

        '<h2 style="font-size:18px;font-weight:800;color:#1a1008;margin:0 0 10px;">You\'re almost there!</h2>',

        '<p style="font-size:14px;color:#555;margin:0 0 24px;line-height:1.6;">',
          'Add <strong style="color:#1a1008;">' + formatMoney(needed * 100) + '</strong> more to unlock <strong style="color:#1a1008;">' + nextTierName + '</strong> on your entire order.',
        '</p>',

        '<div style="height:1px;background:#f0f0f0;margin-bottom:24px;"></div>',

        '<button id="ws-upsell-shop" style="display:block;width:100%;background:linear-gradient(180deg,#f7cd30 0%,#e8b800 100%);color:#1a1000;font-weight:800;font-size:14px;padding:14px;border-radius:8px;border:2px solid #c49a00;cursor:pointer;margin-bottom:10px;">',
          'Keep Shopping',
        '</button>',

        '<button id="ws-upsell-continue" style="display:block;width:100%;background:transparent;color:#888;font-size:13px;padding:10px;border-radius:8px;border:1px solid #eee;cursor:pointer;">',
          'No thanks, continue to checkout',
        '</button>',

      '</div>'
    ].join('');

    document.body.appendChild(overlay);

    var upsellCloseBtn = document.getElementById('ws-upsell-close-btn');
    if (upsellCloseBtn) upsellCloseBtn.addEventListener('click', function() { overlay.remove(); });

    document.getElementById('ws-upsell-shop').addEventListener('click', function() {
      overlay.remove();
      // Close cart drawer if open
      var drawerClose = document.querySelector('.cart-drawer__close, [data-close-drawer], .js-close-drawer');
      if (drawerClose) drawerClose.click();
    });

    document.getElementById('ws-upsell-continue').addEventListener('click', function() {
      overlay.remove();
      onContinue();
    });

    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) overlay.remove();
    });
  }

  function showTierUpBanner(tierIndex) {
    var old = document.querySelector('.ws-tierup-banner');
    if (old) old.remove();
    var banner = document.createElement('div');
    banner.className = 'ws-tierup-banner';
    banner.innerHTML = [
      '<span class="ws-tierup-banner__icon">' + TIER_ICONS[tierIndex] + '</span>',
      '<div class="ws-tierup-banner__text">',
        '<span class="ws-tierup-banner__title">Tier Unlocked!</span>',
        '<span class="ws-tierup-banner__sub">' + TIER_NAMES[tierIndex] + '</span>',
      '</div>'
    ].join('');
    document.body.appendChild(banner);
    setTimeout(function() { banner.remove(); }, 3500);
  }

  // ── Enforce $150 wholesale minimum ──────────────────────────────────────────

  function setCheckoutTemporaryLock(lock) {
    cartMutationPending = !!lock;
    if (lock) wholesaleCheckoutUnlocked = false;
    if (!lock) return;

    [
      document.getElementById('cart-drawer-checkout-btn'),
      document.getElementById('cart-page-checkout-btn')
    ].forEach(function(btn) {
      if (!btn) return;
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('disabled', 'disabled');
      btn.style.pointerEvents = 'none';
      btn.style.opacity       = '0.4';
    });
    enforceCheckoutBlockUI();
  }

  function forceCheckoutBlock(ms) {
    var holdMs = typeof ms === 'number' ? ms : 1200;
    var until  = Date.now() + holdMs;
    if (until > checkoutForceBlockUntil) checkoutForceBlockUntil = until;
    setCheckoutTemporaryLock(true);
  }

  function shouldBlockCheckoutNow() {
    if (!wholesaleEnabled) return false;
    if (lastWholesaleBlocked) return true;
    return false;
  }

  function getCheckoutTargets() {
    var nodes = Array.from(document.querySelectorAll('#cart-page-checkout-btn, #cart-drawer-checkout-btn, [name="checkout"]'));
    var uniq = [];
    nodes.forEach(function(n) {
      if (uniq.indexOf(n) === -1) uniq.push(n);
    });
    return uniq;
  }

  function enforceCheckoutBlockUI() {
    var shouldBlock = shouldBlockCheckoutNow();
    getCheckoutTargets().forEach(function(el) {
      if (!el) return;
      if (shouldBlock) {
        el.setAttribute('aria-disabled', 'true');
        el.setAttribute('disabled', 'disabled');
        el.style.pointerEvents = 'none';
        el.style.opacity       = '0.4';
        if (el.tagName === 'A') {
          if (!el.dataset.wsHrefBackup && el.getAttribute('href')) {
            el.dataset.wsHrefBackup = el.getAttribute('href');
          }
          el.setAttribute('href', 'javascript:void(0)');
        }
      } else if (wholesaleEnabled) {
        el.removeAttribute('aria-disabled');
        el.removeAttribute('disabled');
        el.style.pointerEvents = '';
        el.style.opacity       = '';
        if (el.tagName === 'A' && el.dataset.wsHrefBackup) {
          el.setAttribute('href', el.dataset.wsHrefBackup);
          delete el.dataset.wsHrefBackup;
        }
      }
    });
  }

  function scheduleRetailReconcile() {
    if (wholesaleEnabled) return;
    if (document.activeElement && document.activeElement.type === 'number') return;
    clearTimeout(retailReconcileTimer);
    retailReconcileTimer = setTimeout(function () {
      if (wholesaleEnabled) return;
      if (document.activeElement && document.activeElement.type === 'number') return;
      applyRetailPricesToVisibleCart();
    }, 300);
  }

  function installCheckoutGuards() {
    document.addEventListener('pointerdown', function (e) {
      var t = e.target;
      if (modalDismissed) return;
      if (t && t.closest && t.closest('#ws-minimum-modal')) return;
      if (t && t.closest && t.closest('#ws-upsell-overlay')) return;
      if (shouldBlockCheckoutNow()) {
        if (t && t.closest && t.closest('#cart-page-checkout-btn, #cart-drawer-checkout-btn, [name="checkout"], a[href*="/checkout"]')) {
          e.preventDefault();
          e.stopPropagation();
          showMinimumNotMetModal();
        }
      }
    }, true);

    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && shouldBlockCheckoutNow()) {
        var t = e.target;
        if (t && t.closest && t.closest('#cart-page-checkout-btn, #cart-drawer-checkout-btn, [name="checkout"], a[href*="/checkout"]')) {
          e.preventDefault();
          e.stopPropagation();
        }
      }
    }, true);

    document.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;

      if (target.id === 'ws-minimum-modal' || (target.closest && target.closest('#ws-minimum-modal'))) {
        e.stopImmediatePropagation();
        e.preventDefault();
        if (target.id === 'ws-minimum-modal') { target.remove(); modalDismissed = true; setTimeout(function(){ modalDismissed = false; }, 500); }
        if (target.id === 'ws-min-close-btn') { var m = document.getElementById('ws-minimum-modal'); if (m) m.remove(); modalDismissed = true; setTimeout(function(){ modalDismissed = false; }, 500); }
        if (target.id === 'ws-min-shop-btn') { var ms = document.getElementById('ws-minimum-modal'); if (ms) ms.remove(); modalDismissed = true; setTimeout(function(){ modalDismissed = false; }, 500); var dc = document.querySelector('.cart-drawer__close, [data-close-drawer], .js-close-drawer'); if (dc) dc.click(); }
        return;
      }
      if (target.id === 'ws-upsell-overlay' || (target.closest && target.closest('#ws-upsell-overlay'))) {
        e.stopImmediatePropagation();
        if (target.id === 'ws-upsell-overlay') { target.remove(); }
        if (target.id === 'ws-upsell-close-btn') { var u = document.getElementById('ws-upsell-overlay'); if (u) u.remove(); }
        if (target.id === 'ws-upsell-shop') { var us = document.getElementById('ws-upsell-overlay'); if (us) us.remove(); var dcu = document.querySelector('.cart-drawer__close, [data-close-drawer], .js-close-drawer'); if (dcu) dcu.click(); }
        if (target.id === 'ws-upsell-continue') { var uc = document.getElementById('ws-upsell-overlay'); if (uc) uc.remove(); window.location.href = '/checkout'; }
        return;
      }

      // Pre-lock checkout immediately when quantity controls are used.
      var qtyTrigger = target.closest('.quantity__button, .quantity button, [name="minus"], [name="plus"], [data-quantity-button], [data-quantity-selector]');
      if (wholesaleEnabled && qtyTrigger) forceCheckoutBlock(1500);

      var checkoutTrigger = target.closest('#cart-page-checkout-btn, #cart-drawer-checkout-btn, [name="checkout"]');
      if (!checkoutTrigger) return;

      if (shouldBlockCheckoutNow()) {
        e.preventDefault();
        e.stopPropagation();
        enforceCheckoutBlockUI();
        showMinimumNotMetModal();
        return;
      }

      // Show upsell modal if wholesale is on and close to next tier
      if (wholesaleEnabled && !document.getElementById('ws-upsell-overlay')) {
        var fetcher = nativeFetch || window.fetch.bind(window);
        fetcher('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var total = 0;
            cart.items.forEach(function(item) {
              var wsPrice = null;
              if (item.properties && item.properties['_wholesale_price']) wsPrice = parseInt(item.properties['_wholesale_price'], 10);
              if (!wsPrice && window.wholesaleVariantPrices && window.wholesaleVariantPrices[String(item.variant_id)]) wsPrice = window.wholesaleVariantPrices[String(item.variant_id)].wholesale;
              total += (wsPrice || item.original_price) * item.quantity;
            });

            // Check if upsell should show
            var dollars = total / 100;
            var UPSELL_TIERS = [150, 300, 600, 1200, 5000, 12000];
            var nextTierAmount = null;
            for (var i = 0; i < UPSELL_TIERS.length; i++) {
              if (dollars < UPSELL_TIERS[i]) { nextTierAmount = UPSELL_TIERS[i]; break; }
            }
            var prevAmount = 0;
            if (nextTierAmount) {
              for (var j = UPSELL_TIERS.length - 1; j >= 0; j--) {
                if (UPSELL_TIERS[j] < nextTierAmount && dollars >= UPSELL_TIERS[j]) { prevAmount = UPSELL_TIERS[j]; break; }
              }
            }
            var needed = nextTierAmount ? nextTierAmount - dollars : 0;
            var tierRange = nextTierAmount ? nextTierAmount - prevAmount : 1;
            var pctRemaining = needed / tierRange;
            var shouldShowUpsell = nextTierAmount && pctRemaining <= 0.5;

            if (shouldShowUpsell) {
              showCheckoutUpsellModal(total, function() {
                window.location.href = '/checkout';
              });
            } else {
              window.location.href = '/checkout';
            }
          });

        // Always prevent default and handle navigation ourselves
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      enforceCheckoutBlockUI();
    }, true);

    var cartForm = document.getElementById('cart');
    if (cartForm) {
      cartForm.addEventListener('change', function (e) {
        var target = e.target;
        if (!target || !target.matches) return;
        if (wholesaleEnabled && target.matches('input[name^="updates"], input[name="quantity"], .quantity input')) {
          forceCheckoutBlock(1500);
        }
      }, true);

      cartForm.addEventListener('submit', function (e) {
        var submitter = e.submitter;
        var isCheckoutSubmit = submitter && (
          submitter.id === 'cart-page-checkout-btn' ||
          submitter.id === 'cart-drawer-checkout-btn' ||
          submitter.name === 'checkout'
        );

        // Any non-checkout cart submit (quantity/update) should pre-lock.
        if (wholesaleEnabled && !isCheckoutSubmit) forceCheckoutBlock(1500);

        if (isCheckoutSubmit && shouldBlockCheckoutNow()) {
          e.preventDefault();
          e.stopPropagation();
        }
        enforceCheckoutBlockUI();
      }, true);
    }
  }

  function updateMinimumEnforcement(totalCents) {
    if (totalCents === 0) {
      if (wholesaleEnabled) {
        lastWholesaleBlocked = true;
        wholesaleCheckoutUnlocked = false;
        var btn = document.getElementById('cart-drawer-checkout-btn');
        var btnAnn = document.getElementById('ws-ann-checkout-btn');
        if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.style.opacity = '0.4'; btn.style.cursor = 'not-allowed'; }
        if (btnAnn) { btnAnn.setAttribute('aria-disabled', 'true'); btnAnn.style.opacity = '0.4'; }
      }
      return;
    }
    var MINIMUM = 15000;

    var btn        = document.getElementById('cart-drawer-checkout-btn');
    var msg        = document.getElementById('ws-minimum-message');
    var needed     = document.getElementById('ws-minimum-needed');

    var btnCart    = document.getElementById('cart-page-checkout-btn');
    var msgCart    = document.getElementById('ws-minimum-message-cart');
    var neededCart = document.getElementById('ws-minimum-needed-cart');
    var btnAnn     = document.getElementById('ws-ann-checkout-btn');

    // Block dynamic payment buttons using overlay
    var dynamicContainer = document.querySelector('.dynamic-cart-btns');
    var existingOverlay = document.getElementById('ws-dynamic-btn-overlay');

    var blocked       = wholesaleEnabled && totalCents < MINIMUM;
    lastWholesaleBlocked = blocked;
    wholesaleCheckoutUnlocked = wholesaleEnabled ? !blocked : true;
    var neededDollars = blocked ? ((MINIMUM - totalCents) / 100).toFixed(2) : '0.00';

    // Apply block/unblock to dynamic payment buttons using overlay
    if (dynamicContainer) {
      if (blocked) {
        dynamicContainer.style.position = 'relative';
        if (!existingOverlay) {
          var overlay = document.createElement('div');
          overlay.id = 'ws-dynamic-btn-overlay';
          overlay.style.cssText = 'position:absolute;inset:0;z-index:9999;cursor:not-allowed;background:rgba(255,255,255,0.01);';
          overlay.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            showMinimumModal();
          });
          dynamicContainer.appendChild(overlay);
        }
        dynamicContainer.style.opacity = '0.4';
      } else {
        if (existingOverlay) existingOverlay.remove();
        dynamicContainer.style.opacity = '1';
      }
    }

    [
      { btn: btn,     msg: msg,     needed: needed     },
      { btn: btnCart, msg: msgCart, needed: neededCart },
      { btn: btnAnn,  msg: null,    needed: null       }
    ].forEach(function(els) {
      if (!els.btn) return;
      var isAnn = els.btn.id === 'ws-ann-checkout-btn';
      if (blocked) {
        els.btn.setAttribute('aria-disabled', 'true');
        if (!isAnn) els.btn.setAttribute('disabled', 'disabled');
        els.btn.style.pointerEvents = 'none';
        els.btn.style.opacity       = '0.4';
        els.btn.style.cursor        = 'not-allowed';
        if (!isAnn) els.btn.removeAttribute('href');
        // Add clickable overlay for cart page button to catch clicks and show modal
        if (els.btn.id === 'cart-page-checkout-btn') {
          var wrap = document.getElementById('ws-checkout-btn-wrap');
          if (wrap && !document.getElementById('ws-checkout-click-trap')) {
            var trap = document.createElement('div');
            trap.id = 'ws-checkout-click-trap';
            trap.style.cssText = 'position:absolute;inset:0;cursor:not-allowed;z-index:10;';
            wrap.appendChild(trap);
          }
        }
        if (isAnn) {
          els.btn.style.pointerEvents = 'auto';
          els.btn.style.cursor = 'not-allowed';
        }
        if (els.msg)    els.msg.style.display  = 'block';
        if (els.needed) els.needed.textContent = '$' + neededDollars;
      } else {
        els.btn.removeAttribute('aria-disabled');
        els.btn.removeAttribute('disabled');
        els.btn.style.pointerEvents = 'auto';
        els.btn.style.opacity       = '1';
        els.btn.style.cursor        = '';
        if (els.msg) els.msg.style.display = 'none';
      }
    });
  }

  // ── Update cart attribute ───────────────────────────────────────────────────
  function updateCartAttribute(enable, callback) {
    nativeFetch('/cart/update.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({
        attributes: {
          wholesale_mode: enable ? 'true' : ''
        }
      })
    })
    .then(function () { if (callback) callback(); })
    .catch(function (e) {
      console.warn('[WholesaleToggle] cart update failed:', e);
      if (callback) callback();
    });
  }

  // ── PPLR custom-text price reader ───────────────────────────────────────────
  // Reads the per-unit wholesale price that PPLR has already calculated and
  // displayed on the product page, then applies the wholesale ratio to it.
  // PPLR's unit price element: dd.a_pplr_item_price (on product form page)
  // PPLR's original price element: s.a_pplr_item_oprice
  function getPplrUnitPriceCents() {
    // Look for PPLR's displayed unit price on the product page
    // (not in the cart — those are already-added items)
    var form = document.querySelector('form.pplr_atc_form, form[action*="/cart/add"].js-product-form');
    if (!form) return null;

    // PPLR shows the retail price in a_pplr_item_oprice — use that as the base
    // then apply the wholesale ratio from known variants on this product
    var originalPriceEl = form.querySelector('.a_pplr_item_oprice, [class*="pplr"][class*="oprice"]');
    var retailCents = 0;
    if (originalPriceEl) {
      var txt = originalPriceEl.textContent.replace(/[^0-9.]/g, '');
      retailCents = Math.round(parseFloat(txt) * 100);
    }

    // Fallback: try reading from the standard price element on the page
    if (!retailCents) {
      var stdPrice = document.querySelector('.wholesale-price-wrapper .wholesale-price--retail, [data-regular-price]');
      if (stdPrice) {
        var txt2 = stdPrice.textContent || stdPrice.getAttribute('data-regular-price') || '';
        retailCents = Math.round(parseFloat(txt2.replace(/[^0-9.]/g, '')) * 100);
      }
    }

    if (!retailCents) return null;

    // Get the wholesale ratio from known variants on this product
    if (window.wholesaleVariantPrices) {
      var ids = Object.keys(window.wholesaleVariantPrices);
      for (var i = 0; i < ids.length; i++) {
        var vp = window.wholesaleVariantPrices[ids[i]];
        if (vp.regular && vp.wholesale && vp.regular > 0) {
          return Math.round(retailCents * (vp.wholesale / vp.regular));
        }
      }
    }

    return null;
  }

  // ── Add-to-cart intercept ───────────────────────────────────────────────────
  function attachWholesaleToFormData(formData) {
    var variantId      = String(formData.get('id') || '');
    var wholesalePrice = getWholesalePriceForVariant(variantId);

    // PPLR custom-text fallback: read the per-unit price PPLR already calculated
    if (!wholesalePrice) {
      wholesalePrice = getPplrUnitPriceCents();
    }

    if (!wholesalePrice) return formData;

    var newFD = new FormData();
    for (var pair of formData.entries()) newFD.append(pair[0], pair[1]);
    newFD.set('properties[_wholesale_price]', wholesalePrice);
    newFD.set('properties[_wholesale_mode]',  'true');
    return newFD;
  }

  function attachWholesaleToJSON(payload) {
    function enrich(item) {
      var id    = String(item.id || item.variant_id || '');
      var price = getWholesalePriceForVariant(id);

      // PPLR custom-text fallback
      if (!price) price = getPplrUnitPriceCents();

      if (price) {
        item.properties = Object.assign({}, item.properties || {}, {
          _wholesale_price: price,
          _wholesale_mode:  'true'
        });
      }
      return item;
    }
    if (Array.isArray(payload.items)) {
      payload.items = payload.items.map(enrich);
    } else {
      payload = enrich(payload);
    }
    return payload;
  }

  function getFetchResourceUrl(resource) {
    if (typeof resource === 'string') return resource;
    if (resource && typeof resource.url === 'string') return resource.url;
    return '';
  }

  function getFetchMethod(resource, config) {
    if (config && config.method) return String(config.method).toUpperCase();
    if (resource && resource.method) return String(resource.method).toUpperCase();
    return 'GET';
  }

  // ── Patch PPLR cart items missing _wholesale_price ──────────────────────────
  function patchPplrCartItems(cart) {
    if (!wholesaleEnabled) return;
    var updates = [];

    cart.items.forEach(function(item, index) {
      var props = item.properties || {};

      // Always re-patch PPLR items to ensure surcharge is correct
      var isPplr = props['_pplr_ref_variant'] || props['_pplr_cart_variant'];
      if (!isPplr) {
        // _pplr_cart_variant not written yet — schedule a retry
        if (props['_pplr_preview'] || props['Preview']) {
          // Zepto hasn't written _pplr_cart_variant yet — retry after it does.
          // Also call applyCartStateFromCart so the DOM price updates once patched.
          var _retryItem = item;
          function _retryPplrPatch(delay) {
            setTimeout(function() {
              _cartFetchLastResult = null;
              throttledCartFetch(function(retryCart) {
                var retryItem = retryCart.items.find(function(i) { return i.key === _retryItem.key; });
                if (retryItem && retryItem.properties && (retryItem.properties['_pplr_cart_variant'] || retryItem.properties['_pplr_ref_variant'])) {
                  patchPplrCartItems(retryCart);
                  applyCartStateFromCart(retryCart, wholesaleEnabled);
                } else if (retryItem && (retryItem.properties['_pplr_preview'] || retryItem.properties['Preview'])) {
                  // Still not ready — retry once more
                  if (delay < 10000) _retryPplrPatch(delay * 2);
                }
              });
            }, delay);
          }
          _retryPplrPatch(3000);
          return;
        }
        // CUSTOM SKU — use quantity tier pricing
        var itemSku = (item.sku || '').toUpperCase();
        if (itemSku.indexOf('CUSTOM') === 0 && window.wsCustomTiers && window.wsCustomTiers[itemSku]) {
          var skuTotalQty = 0;
          cart.items.forEach(function(ci) {
            if ((ci.sku || '').toUpperCase() === itemSku) skuTotalQty += ci.quantity;
          });
          var tierPrice = getCustomTierPriceCents(itemSku, skuTotalQty);
          if (tierPrice) {
            var existingCustomWp = parseInt(props['_wholesale_price'], 10);
            if (existingCustomWp !== tierPrice || props['_wholesale_mode'] !== 'true') {
              updates.push({
                key: item.key,
                quantity: item.quantity,
                properties: Object.assign({}, props, {
                  _wholesale_price: tierPrice,
                  _wholesale_mode: 'true',
                  _ws_price: String(tierPrice)
                })
              });
            }
          }
          return;
        }

        // Non-Zepto product — fetch wholesale price from product JSON if missing
        if (!window.wholesaleVariantPrices || !window.wholesaleVariantPrices[String(item.variant_id)]) {
          var handle = item.handle;
          if (handle) {
            ensureVariantPrices(item.variant_id, handle, function(vp) {
              if (vp) {
                var updates2 = [{
                  key: item.key,
                  quantity: item.quantity,
                  properties: Object.assign({}, props, {
                    _wholesale_price: vp.wholesale,
                    _wholesale_mode: 'true',
                    _ws_price: String(vp.wholesale)
                  })
                }];
                Promise.all(updates2.map(function(u) {
                  return nativeFetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: u.key, quantity: u.quantity, properties: u.properties })
                  });
                })).then(function() {
                  _cartFetchLastResult = null;
                  throttledCartFetch(function(updatedCart) {
                    _cachedCart = updatedCart;
                    applyCartStateFromCart(updatedCart, wholesaleEnabled);
                  });
                });
              }
            });
          }
        }
        return;
      }

      var wholesalePrice = null;

      // ── Type A: _pplr_ref_variant ─────────────────────────────────────────
      // Zepto created a dynamic variant. Use ref variant to look up base
      // wholesale, then add surcharge = item.original_price - base regular.
      if (props['_pplr_ref_variant']) {
        try {
          var refParsed = JSON.parse(props['_pplr_ref_variant']);
          var refKey = String(refParsed.variant_id || '');
          var refVp = window.wholesaleVariantPrices && window.wholesaleVariantPrices[refKey];
          if (refVp && refVp.regular && refVp.wholesale) {
            var refSurcharge = Math.max(0, item.original_price - refVp.regular);
            wholesalePrice = refVp.wholesale + refSurcharge;
          }
        } catch(e) {}
      }

      // ── Type B: _pplr_cart_variant ────────────────────────────────────────
      // Zepto stored {variantId: [qty, "zetoPriceString"]}. The key IS the
      // variant ID so we can look it up directly in wholesaleVariantPrices.
      // Surcharge = Zepto retail price - base regular price.
      if (!wholesalePrice && props['_pplr_cart_variant']) {
        try {
          var cvParsed = JSON.parse(props['_pplr_cart_variant']);
          var cvKey = Object.keys(cvParsed)[0];
          var cvZetoCents = Math.round(parseFloat(cvParsed[cvKey][1]) * 100);
          var cvVp = window.wholesaleVariantPrices && window.wholesaleVariantPrices[cvKey];
          if (!cvVp && item.handle) {
            // variant not in wholesaleVariantPrices — fetch from product JSON
            ensureVariantPrices(cvKey, item.handle, function(vp) {
              if (vp && wholesaleEnabled) {
                var surcharge = Math.max(0, cvZetoCents - vp.regular);
                var wp = vp.wholesale + surcharge;
                nativeFetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    id: item.key,
                    quantity: item.quantity,
                    properties: Object.assign({}, props, {
                      _wholesale_price: wp,
                      _wholesale_mode: 'true',
                      _ws_price: String(wp)
                    })
                  })
                }).then(function() {
                  _cartFetchLastResult = null;
                  throttledCartFetch(function(updatedCart) {
                    _cachedCart = updatedCart;
                    applyCartStateFromCart(updatedCart, wholesaleEnabled);
                  });
                });
              }
            });
          } else if (cvZetoCents > 0 && cvVp && cvVp.regular && cvVp.wholesale) {
            var cvSurcharge = Math.max(0, cvZetoCents - cvVp.regular);
            wholesalePrice = cvVp.wholesale + cvSurcharge;
          }
        } catch(e) {}
      }

      if (!wholesalePrice) return;

      // Skip if already correctly patched
      var existingWp = parseInt(props['_wholesale_price'], 10);
      if (existingWp === wholesalePrice && props['_wholesale_mode'] === 'true') return;

      // If existing _wholesale_price is already higher than what we computed
      // (meaning a surcharge was previously calculated correctly), trust it
      // rather than overwriting with a lower base-only price.
      if (existingWp > wholesalePrice && props['_wholesale_mode'] === 'true') return;

      updates.push({
        key: item.key,
        quantity: item.quantity,
        properties: Object.assign({}, props, {
          _wholesale_price: wholesalePrice,
          _wholesale_mode: 'true',
          _ws_price: String(wholesalePrice)
        })
      });
    });

    if (updates.length === 0) return;

    // Send all patches in parallel to avoid Shopify merging duplicate variants
    updates.reduce(function(chain, update) {
      return chain.then(function() {
        return nativeFetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: update.key,
            quantity: update.quantity,
            properties: update.properties
          })
        });
      });
    }, Promise.resolve()).then(function() {
      setTimeout(function() {
        _cartFetchLastResult = null;
        throttledCartFetch(function(updatedCart) {
          _cachedCart = updatedCart;
          applyCartStateFromCart(updatedCart, wholesaleEnabled);
          if (window.wsUpdateProgress) window.wsUpdateProgress(0);
        });
      }, 300);
    }).catch(function(e) {
      console.warn('[WholesaleToggle] patchPplrCartItems failed:', e);
    });
  }

  function interceptAddToCart() {
    nativeFetch = window.fetch.bind(window);

    // ── Global cart.js rate limiter — max 1 request per 1200ms ──────────────
    var _cartRateTimer = null;
    var _cartRateQueue = [];
    var _cartRateLastCall = 0;
    var _cartRateInFlight = false;
    function _rateLimitedCartFetch() {
      var now = Date.now();
      if (_cartRateInFlight || (now - _cartRateLastCall) < 1200) {
        if (!_cartRateTimer) {
          _cartRateTimer = setTimeout(function() {
            _cartRateTimer = null;
            _rateLimitedCartFetch();
          }, 1200 - (Date.now() - _cartRateLastCall));
        }
        return;
      }
      _cartRateLastCall = now;
      _cartRateInFlight = true;
      var cbs = _cartRateQueue.splice(0);
      nativeFetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          _cartFetchLastResult = cart;
          _cartFetchLastTime = Date.now();
          _cartRateInFlight = false;
          cbs.forEach(function(fn) { fn(cart); });
        })
        .catch(function() {
          _cartRateInFlight = false;
        });
    }
    var _origThrottledCartFetch = throttledCartFetch;
    throttledCartFetch = function(cb) {
      _cartRateQueue.push(cb);
      _rateLimitedCartFetch();
    };

    window.fetch = function () {
      var args     = Array.prototype.slice.call(arguments);
      var resource = args[0];
      var config   = args[1] || {};

      var resourceUrl = getFetchResourceUrl(resource);
      var method      = getFetchMethod(resource, config);

      if (wholesaleEnabled && resourceUrl.includes('/cart/add')) {
        try {
          if (config.body instanceof FormData) {
            config  = Object.assign({}, config, { body: attachWholesaleToFormData(config.body) });
            args[1] = config;
          } else if (typeof config.body === 'string') {
            var parsed = JSON.parse(config.body);
            config     = Object.assign({}, config, { body: JSON.stringify(attachWholesaleToJSON(parsed)) });
            args[1]    = config;
          }
        } catch (err) {
          console.warn('[WholesaleToggle] intercept error:', err);
        }
      }

      var isCartMutation = resourceUrl.indexOf('/cart') !== -1 &&
        resourceUrl.indexOf('/cart.js') === -1 &&
        (method !== 'GET' || !!config.body);

      if (wholesaleEnabled && isCartMutation) forceCheckoutBlock(1500);

      var result = nativeFetch.apply(null, args);

      // Re-enforce cart page minimum after any cart mutation
      if (isCartMutation && !window._pplrPatching) {
        result.then(function() {
          setTimeout(function() {
            _cartFetchLastResult = null;
            throttledCartFetch(function(cart) {
                _cachedCart = cart;
                if (wholesaleEnabled) {
                  var needsPplrPatch = resourceUrl.includes('/cart/add') && cart.items.some(function(item) {
                    var props = item.properties || {};
                    var isPplr = props['_pplr_ref_variant'] || props['_pplr_cart_variant'];
                    // Also catch Zepto items mid-flight: _pplr_cart_variant not yet written
                    var isPplrInFlight = !isPplr && (props['_pplr_preview'] || props['Preview']);
                    if (isPplrInFlight) return true;
                    if (!isPplr) return false;
                    if (!props['_wholesale_price']) return true;
                    if (props['_pplr_cart_variant']) {
                      try {
                        var cvParsed = JSON.parse(props['_pplr_cart_variant']);
                        var cvKey = Object.keys(cvParsed)[0];
                        var cvZetoCents = Math.round(parseFloat(cvParsed[cvKey][1]) * 100);
                        var cvVp = window.wholesaleVariantPrices && window.wholesaleVariantPrices[cvKey];
                        if (cvVp && cvVp.regular && cvVp.wholesale) {
                          var expected = cvVp.wholesale + Math.max(0, cvZetoCents - cvVp.regular);
                          if (parseInt(props['_wholesale_price'], 10) !== expected) return true;
                        }
                      } catch(e) {}
                    }
                    return false;
                  });
                  if (needsPplrPatch) {
                    setTimeout(function() {
                      window._pplrPatching = true;
                      _cartFetchLastResult = null;
                      throttledCartFetch(function(cart2) {
                        _cachedCart = cart2;
                        patchPplrCartItems(cart2);
                        applyCartStateFromCart(cart2, wholesaleEnabled);
                        cartMutationPending = false;
                        window._pplrPatching = false;
                      });
                    }, 800);
                    return;
                  }
                  patchPplrCartItems(cart);
                }
                applyCartStateFromCart(cart, wholesaleEnabled);
                cartMutationPending = false;
              });
          }, 120);
        }).catch(function() {
          // Keep lock unless minimum enforcement explicitly re-enables checkout.
        });
      }

      return result;
    };

    // XHR fallback — intercept open() to track URL, then send() to patch
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url) {
      if (this instanceof XMLHttpRequest) {
        this._ws_url = url;
      }
      return origOpen.apply(this, arguments);
    };

    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function (body) {
      if (wholesaleEnabled && this._ws_url && this._ws_url.includes('/cart/add')) {
        try {
          var parsed = JSON.parse(body);
          body = JSON.stringify(attachWholesaleToJSON(parsed));
        } catch (e) { /* non-JSON */ }
      }
      return origSend.apply(this, [body]);
    };
  }

  function setAnnouncementProgress(enable) {
    var wrapper = document.getElementById('ws-announcement-progress');
    if (!wrapper) return;
    wrapper.style.display = enable ? 'flex' : 'none';
  }

  // ── Toggle UI ───────────────────────────────────────────────────────────────
  function setToggleUI(enable) {
    var retailBtn    = document.getElementById('ws-mode-retail');
    var wholesaleBtn = document.getElementById('ws-mode-wholesale');
    var wrapper      = document.getElementById('wholesale-toggle-wrapper');
    var mobileWrapper = document.getElementById('wholesale-toggle-wrapper-mobile');
    if (mobileWrapper) {
      mobileWrapper.classList.toggle('is-wholesale', enable);
      mobileWrapper.classList.toggle('is-retail', !enable);
      var mr = document.getElementById('ws-mode-retail-mobile');
      var mw = document.getElementById('ws-mode-wholesale-mobile');
      if (enable) {
        if (mw) mw.classList.add('ws-mode-toggle__btn--active');
        if (mr) mr.classList.remove('ws-mode-toggle__btn--active');
      } else {
        if (mr) mr.classList.add('ws-mode-toggle__btn--active');
        if (mw) mw.classList.remove('ws-mode-toggle__btn--active');
      }
    }
    if (!retailBtn || !wholesaleBtn) return;

    if (enable) {
      wholesaleBtn.classList.add('ws-mode-toggle__btn--active');
      wholesaleBtn.setAttribute('aria-pressed', 'true');
      retailBtn.classList.remove('ws-mode-toggle__btn--active');
      retailBtn.setAttribute('aria-pressed', 'false');
      if (wrapper) {
        wrapper.classList.add('is-wholesale');
        wrapper.classList.remove('is-retail');
      }
    } else {
      retailBtn.classList.add('ws-mode-toggle__btn--active');
      retailBtn.setAttribute('aria-pressed', 'true');
      wholesaleBtn.classList.remove('ws-mode-toggle__btn--active');
      wholesaleBtn.setAttribute('aria-pressed', 'false');
      if (wrapper) {
        wrapper.classList.add('is-retail');
        wrapper.classList.remove('is-wholesale');
      }
    }
  }

  function applyState(enable) {
    wholesaleEnabled = enable;
    sessionStorage.setItem(STORAGE_KEY, enable ? 'true' : 'false');
    setToggleUI(enable);
    // Sync wholesale state to cart attribute so Function API can read it
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { wholesale_mode: enable ? 'true' : '' }
      })
    });
    setAnnouncementProgress(enable);
    document.querySelectorAll('a[href="/pages/smart-blonde-wholesale-info"]').forEach(function(el) {
      el.style.display = enable ? 'none' : '';
    });

// Update banner button and subtext
    var bannerBtn = document.querySelector('.banner-btn-secondary');
    var bannerNote = document.getElementById('ws-banner-note-text');
    if (bannerBtn) {
      bannerBtn._originalText = bannerBtn._originalText || bannerBtn.textContent;
      bannerBtn.textContent = enable ? 'See Wholesale Discount Tiers & Savings' : bannerBtn._originalText;
      if (enable) {
        bannerBtn.classList.add('ws-active');
      } else {
        bannerBtn.classList.remove('ws-active');
      }
    }
    if (bannerNote) {
      bannerNote._originalText = bannerNote._originalText || bannerNote.textContent;
      bannerNote.textContent = enable ? 'Welcome to Smart Blonde Wholesale!' : bannerNote._originalText;
      var bannerInfoBtn = document.getElementById('ws-banner-info-btn');
      if (bannerInfoBtn) bannerInfoBtn.style.display = enable ? 'none' : 'inline-flex';
    }
    var shippingEl = Array.from(document.querySelectorAll('.icons-with-text__title')).find(function(el) {
      return el.textContent.includes('Free Shipping');
    });
    if (shippingEl) {
      shippingEl._originalText = shippingEl._originalText || shippingEl.innerHTML;
      shippingEl.innerHTML = enable ? '<strong>Free Shipping Over $600</strong>' : shippingEl._originalText;
    }
    swapPrices(enable);
    updateCheckoutLink(enable);
    document.dispatchEvent(new CustomEvent('wholesale:toggled'));
    if (!enable) {
      lastWholesaleBlocked = false;
      cartMutationPending = false;
      wholesaleCheckoutUnlocked = true;
      checkoutForceBlockUntil = 0;
      var msgCart = document.getElementById('ws-minimum-message-cart');
      if (msgCart) msgCart.style.display = 'none';
    }
    if (enable) {
      clearTimeout(retailReconcileTimer);
      forceCheckoutBlock(1500);
    }

    // Always bust the cache on toggle so stale retail-stripped data is never reused
    _cachedCart = null;
    _cartFetchLastResult = null;

    updateCartAttribute(enable, function () {
      throttledCartFetch(function(freshCart) {
        _cachedCart = freshCart;
        if (enable) {
          preloadCustomTiers(freshCart.items).then(function() {
            _applyStateWithCart(freshCart, true);
          });
        } else {
          _applyStateWithCart(freshCart, false);
        }
      });
    });
  }

  var _disableChainId = 0;

  function _applyStateWithCart(cart, enable) {
  if (!enable) {
    ++_disableChainId; // cancel any queued enable work
    applyRetailPricesToVisibleCart();
    return;
  }
  // Toggle just turned ON — bust cache, ensure variant prices loaded, then re-write
  ++_disableChainId; // cancel any in-flight disable chain
  _cartFetchLastResult = null;
  _cachedCart = null;
  nativeFetch('/cart.js').then(function(r) { return r.json(); }).then(function(freshCart) {
    _cachedCart = freshCart;
    _cartFetchLastResult = freshCart;
    _cartFetchLastTime = Date.now();

    // First ensure wholesaleVariantPrices is populated for all non-Zepto items
    var nonZeptoItems = freshCart.items.filter(function(item) {
      var props = item.properties || {};
      return !(props['_pplr_cart_variant'] || props['_pplr_ref_variant'] || props['_pplr_preview'] || props['Preview']);
    });

    var priceLoads = nonZeptoItems.map(function(item) {
      return new Promise(function(resolve) {
        if (window.wholesaleVariantPrices && window.wholesaleVariantPrices[String(item.variant_id)]) {
          resolve();
        } else if (item.handle) {
          ensureVariantPrices(item.variant_id, item.handle, function() { resolve(); });
        } else {
          resolve();
        }
      });
    });

    Promise.all(priceLoads).then(function() {
      var rewriteUpdates = nonZeptoItems.filter(function(item) {
        return window.wholesaleVariantPrices && window.wholesaleVariantPrices[String(item.variant_id)];
      }).map(function(item) {
        var wp = window.wholesaleVariantPrices[String(item.variant_id)].wholesale;
        return { key: item.key, quantity: item.quantity, properties: Object.assign({}, item.properties, { _wholesale_price: wp, _wholesale_mode: 'true', _ws_price: String(wp) }) };
      });

      function finalize() {
        window._pplrPatching = false;
        _cartFetchLastResult = null;
        throttledCartFetch(function(rewrittenCart) {
          _cachedCart = rewrittenCart;
          patchPplrCartItems(rewrittenCart);
          applyCartStateFromCart(rewrittenCart, true);
          applyTierPricesToCart();
          if (window.wsUpdateProgress) window.wsUpdateProgress();
        });
      }

      if (rewriteUpdates.length > 0) {
        window._pplrPatching = true;
        rewriteUpdates.reduce(function(chain, upd) {
          return chain.then(function() {
            return nativeFetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(upd) });
          });
        }, Promise.resolve()).then(finalize);
      } else {
        patchPplrCartItems(freshCart);
        applyCartStateFromCart(freshCart, true);
        applyTierPricesToCart();
        if (window.wsUpdateProgress) window.wsUpdateProgress();
      }
    });
  });
}

  // ── Variant change ──────────────────────────────────────────────────────────
  var _productJsonCache = null;
  function resolveVariantFromOptions(e, cb) {
    var scope = (e && e.target && e.target.closest &&
      (e.target.closest('form') || e.target.closest('.js-product-details, .product'))) || document;
    var selected = [];
    scope.querySelectorAll('input.js-option:checked, select.js-option, input[name^="options"]:checked, select[name^="options"]').forEach(function(el) {
      if (el.value && selected.indexOf(el.value) === -1) selected.push(el.value);
    });
    if (!selected.length) { cb(null); return; }
    function match(p) {
      if (!p || !p.variants) { cb(null); return; }
      var found = p.variants.find(function(v) {
        return v.options.every(function(o) { return selected.indexOf(o) !== -1; });
      });
      cb(found ? String(found.id) : null);
    }
    var path = window.location.pathname;
    var qaOpen = getOpenQuickAdd();
    if (qaOpen) {
      var qaLink = qaOpen.querySelector('a[href*="/products/"]');
      if (!qaLink) { cb(null); return; }
      path = new URL(qaLink.href, window.location.origin).pathname;
    }
    if (path.indexOf('/products/') === -1) { cb(null); return; }
    path = '/products/' + path.split('/products/')[1].split('/')[0];
    _productJsonCache = _productJsonCache || {};
    if (_productJsonCache[path]) { match(_productJsonCache[path]); return; }
    (nativeFetch || window.fetch.bind(window))(path + '.js')
      .then(function(r) { return r.json(); })
      .then(function(p) { _productJsonCache[path] = p; match(p); })
      .catch(function() { cb(null); });
  }

    // Quick-add drawer HTML is injected, so its <script> tags never run.
  // Read the wholesale prices straight out of the script text instead.
  function getOpenQuickAdd() {
    return document.querySelector('quick-add-drawer[aria-hidden="false"]');
  }
  function harvestQuickAddPrices() {
    var qa = getOpenQuickAdd();
    if (!qa) return;
    window.wholesaleVariantPrices = window.wholesaleVariantPrices || {};
    qa.querySelectorAll('script').forEach(function(s) {
      var re = /wholesaleVariantPrices\["(\d+)"\]\s*=\s*\{\s*regular:\s*(\d+),\s*wholesale:\s*(\d+)\s*\}/g, m;
      while ((m = re.exec(s.textContent))) {
        window.wholesaleVariantPrices[m[1]] = { regular: parseInt(m[2], 10), wholesale: parseInt(m[3], 10) };
      }
    });
  }

  var variantDebounce;
  function handleVariantChange(e) {
    clearTimeout(variantDebounce);
    variantDebounce = setTimeout(function () {
      harvestQuickAddPrices();
      var variantId = null;
      if (e && e.detail) {
        if (e.detail.variant)   variantId = String(e.detail.variant.id);
        if (e.detail.variantId) variantId = String(e.detail.variantId);
      }
      if (!variantId) {
        resolveVariantFromOptions(e, function(id) {
          if (id) handleVariantChange({ detail: { variantId: id } });
        });
        return;
      }

      var prices = window.wholesaleVariantPrices && window.wholesaleVariantPrices[variantId];

      var containers = [
        document.querySelector('quick-add-drawer[aria-hidden="false"]'),
        document.querySelector('.quick-add-drawer .js-product-details'),
        document.querySelector('.quick-add-drawer'),
        document.querySelector('.js-product-details'),
        document.querySelector('.product'),
        document.body
      ];

      var wrapper = null;
      for (var i = 0; i < containers.length; i++) {
        if (!containers[i]) continue;
        wrapper = containers[i].querySelector('.wholesale-price-wrapper');
        if (wrapper) break;
      }

      if (wrapper && prices) {
        wrapper.dataset.variantId      = variantId;
        wrapper.dataset.regularPrice   = prices.regular;
        wrapper.dataset.wholesalePrice = prices.wholesale;
      }

      swapPrices(wholesaleEnabled);
    }, 80);
  }

  function attachMessageToSummary() {
    var msg     = document.getElementById('ws-minimum-message-cart');
    var summary = document.getElementById('cart-summary');
    if (!msg || !summary) return;

    // Undo old wrapper behavior if present (it moved the summary block unexpectedly).
    var maybeWrapper = summary.parentElement;
    if (maybeWrapper && maybeWrapper.id === 'ws-summary-stack' && maybeWrapper.parentElement) {
      var outer = maybeWrapper.parentElement;
      outer.insertBefore(summary, maybeWrapper);
      if (msg.parentElement === maybeWrapper) outer.insertBefore(msg, maybeWrapper);
      maybeWrapper.remove();
    }

    // Keep message outside summary, directly beneath it.
    if (summary.nextElementSibling !== msg) summary.insertAdjacentElement('afterend', msg);

    // Place message by explicit coordinates so it stays directly below summary.
    var cartForm     = document.getElementById('cart') || summary.closest('form') || summary.parentElement;
    var containerRect = cartForm.getBoundingClientRect();
    var checkoutBtn   = summary.querySelector('#cart-page-checkout-btn');
    var anchorRect    = checkoutBtn ? checkoutBtn.getBoundingClientRect() : summary.getBoundingClientRect();
    var summaryRect   = summary.getBoundingClientRect();
    var anchorWidth   = Math.round(anchorRect.width);
    var leftOffset    = Math.round(anchorRect.left - containerRect.left);
    var topOffset     = Math.round(summaryRect.bottom - containerRect.top + 4);

    if (anchorWidth > 0) msg.style.width = anchorWidth + 'px';
    msg.style.boxSizing   = 'border-box';
    msg.style.position    = 'absolute';
    msg.style.left        = leftOffset + 'px';
    msg.style.top         = topOffset + 'px';
    msg.style.marginTop   = '0';
    msg.style.marginLeft  = '0';
    msg.style.marginRight = '0';
    msg.style.zIndex      = '2';
    msg.style.flex        = '0 0 auto';
    msg.style.alignSelf   = 'auto';

    if (!wholesaleEnabled) msg.style.display = 'none';
  }


  // ── MutationObserver ────────────────────────────────────────────────────────
  function observeDOM() {
    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (m) {
        return Array.from(m.addedNodes).some(function (n) {
          return n.nodeType === 1 && (
            (n.classList && n.classList.contains('wholesale-price-wrapper')) ||
            (n.querySelector && n.querySelector('.wholesale-price-wrapper'))
          );
        });
      });
      if (relevant) swapPrices(wholesaleEnabled);

      var bannerInfoAppeared = mutations.some(function(m) {
        return Array.from(m.addedNodes).some(function(n) {
          return n.nodeType === 1 && (
            n.id === 'ws-banner-info-btn' ||
            (n.querySelector && n.querySelector('#ws-banner-info-btn'))
          );
        });
      });
      if (bannerInfoAppeared) attachInfoBtn();

      var btnAppeared = mutations.some(function (m) {
        return Array.from(m.addedNodes).some(function (n) {
          return n.nodeType === 1 && (
            n.id === 'cart-drawer-checkout-btn' ||
            n.id === 'cart-page-checkout-btn' ||
            (n.querySelector && (n.querySelector('#cart-drawer-checkout-btn') || n.querySelector('#cart-page-checkout-btn')))
          );
        });
      });
      if (btnAppeared) {
        updateCheckoutLink(wholesaleEnabled);
        if (wholesaleEnabled && (Date.now() < checkoutForceBlockUntil || cartMutationPending || lastWholesaleBlocked)) {
          setCheckoutTemporaryLock(true);
        }
      }

      var cartItemsAppeared = mutations.some(function (m) {
        return Array.from(m.addedNodes).some(function (n) {
          return n.nodeType === 1 && (
            (n.classList && n.classList.contains('cart-item')) ||
            (n.querySelector && n.querySelector('.cart-item'))
          );
        });
      });
      if (cartItemsAppeared && !wholesaleEnabled) {
        if (!document.activeElement || document.activeElement.type !== 'number') {
          scheduleRetailReconcile();
        } else {
          var activeInput = document.activeElement;
          activeInput.addEventListener('blur', function onBlur() {
            activeInput.removeEventListener('blur', onBlur);
            setTimeout(function() {
              if (!wholesaleEnabled) {
                _cartFetchLastResult = null;
                throttledCartFetch(function(cart) {
                  applyRetailPricesToVisibleCart();
                });
              }
            }, 1000);
          }, { once: true });
        }
      }
      if (cartItemsAppeared && sessionStorage.getItem('wholesale_enabled') === 'true') {
        clearTimeout(window._pplrAppearDebounce);
        window._pplrAppearDebounce = setTimeout(function() {
          throttledCartFetch(function(cart) {
            patchPplrCartItems(cart);
            applyCartStateFromCart(cart, wholesaleEnabled);
          });
        }, 800);
      }

      // ── PPLR price watcher ───────────────────────────────────────────────────
      // PPLR updates a_pplr_item_price text content when it finishes pricing.
      // Watch for any mutation targeting or containing those elements.
      var pplrPriceChanged = mutations.some(function(m) {
        // characterData mutation directly on a text node inside pplr price el
        if (m.type === 'characterData') {
          var el = m.target.parentElement;
          return el && el.classList && (
            el.classList.contains('a_pplr_item_price') ||
            el.classList.contains('a_pplr_item_oprice')
          );
        }
        // childList mutation — new row or price node added
        if (m.type === 'childList') {
          return Array.from(m.addedNodes).some(function(n) {
            if (n.nodeType === 1) {
              return (n.classList && (
                n.classList.contains('pplr_cart_row') ||
                n.classList.contains('a_pplr_item_price')
              )) || (n.querySelector && (
                n.querySelector('.pplr_cart_row') ||
                n.querySelector('.a_pplr_item_price')
              ));
            }
            // text node inside a pplr price element
            if (n.nodeType === 3) {
              var parent = n.parentElement;
              return parent && parent.classList && (
                parent.classList.contains('a_pplr_item_price') ||
                parent.classList.contains('a_pplr_item_oprice')
              );
            }
            return false;
          });
        }
        return false;
      });
      if (!window._pplrInitPatched && sessionStorage.getItem('wholesale_enabled') === 'true') {
        var pplrEl = document.querySelector('.a_pplr_item_price');
        if (pplrEl && pplrEl.textContent.trim() !== '') {
          window._pplrInitPatched = true;
          clearTimeout(window._pplrAppearDebounce);
          window._pplrAppearDebounce = setTimeout(function() {
            throttledCartFetch(function(cart) { patchPplrCartItems(cart); });
          }, 800);
        }
      }
      if (pplrPriceChanged && sessionStorage.getItem('wholesale_enabled') === 'true') {
        clearTimeout(window._pplrPatchDebounce);
        window._pplrPatchDebounce = setTimeout(function() {
          throttledCartFetch(function(cart) {
            var needsPatch = cart.items.some(function(item) {
              var props = item.properties || {};
              var isPplr = props['_pplr_ref_variant'] || props['_pplr_cart_variant'];
              if (!isPplr) return false;
              var wp = props['_wholesale_price'];
              if (!wp) return true;
              if (props['_pplr_cart_variant']) {
                try {
                  var cvParsed = JSON.parse(props['_pplr_cart_variant']);
                  var cvKey = Object.keys(cvParsed)[0];
                  var cvZetoCents = Math.round(parseFloat(cvParsed[cvKey][1]) * 100);
                  var cvVp = window.wholesaleVariantPrices && window.wholesaleVariantPrices[cvKey];
                  if (cvVp && cvVp.regular && cvVp.wholesale) {
                    var expected = cvVp.wholesale + Math.max(0, cvZetoCents - cvVp.regular);
                    if (parseInt(wp, 10) !== expected) return true;
                  }
                } catch(e) {}
              }
              return false;
            });
            if (needsPatch) patchPplrCartItems(cart);
          });
        }, 800);
      }

      var summaryAppeared = mutations.some(function (m) {
        return Array.from(m.addedNodes).some(function (n) {
          return n.nodeType === 1 && (
            n.id === 'cart-summary' ||
            n.id === 'ws-minimum-message-cart' ||
            (n.querySelector && (n.querySelector('#cart-summary') || n.querySelector('#ws-minimum-message-cart')))
          );
        });
      });
      if (summaryAppeared) attachMessageToSummary();
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });

    document.addEventListener('cart:open', function () {
      updateCheckoutLink(wholesaleEnabled);
      if (window.wsUpdateProgress) window.wsUpdateProgress();
    });

    document.addEventListener('dispatch:cart-drawer:open', function () {
      if (wholesaleEnabled) {
        setTimeout(applyTierPricesToCart, 400);
        setTimeout(applyTierPricesToCart, 800);
        setTimeout(applyTierPricesToCart, 1200);
      }
    });

    var cartIconEl = document.getElementById('cart-icon');
    if (cartIconEl) {
      cartIconEl.addEventListener('click', function() {
        if (wholesaleEnabled) {
          setTimeout(applyTierPricesToCart, 500);
          setTimeout(applyTierPricesToCart, 900);
          setTimeout(applyTierPricesToCart, 1400);
        }
      });
    }

    var cartObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          var bar = node.id === 'wholesale-progress-bar'
            ? node
            : node.querySelector && node.querySelector('#wholesale-progress-bar');
          if (bar) {
            if (window.wsUpdateProgress) window.wsUpdateProgress();
            updateCheckoutLink(wholesaleEnabled);
          }
        });
      });
    });
    cartObserver.observe(document.body, { childList: true, subtree: true });
  }

  // ── Init ────────────────────────────────────────────────────────────────────
  function init() {
    interceptAddToCart();

    if (sessionStorage.getItem('ws_just_signed_out') === 'true') {
      sessionStorage.removeItem('ws_just_signed_out');
      sessionStorage.setItem('wholesale_enabled', 'false');
      wholesaleEnabled = false;
    }

    if (window.wsCustomerDropship) {
      wholesaleEnabled = false;
      sessionStorage.setItem('wholesale_enabled', 'false');
      updateCartAttribute(false, null);
      var toggleWrapper = document.getElementById('wholesale-toggle-wrapper');
      if (toggleWrapper) toggleWrapper.style.display = 'none';
      var annBar = document.getElementById('ws-announcement-progress');
      if (annBar) annBar.style.display = 'none';
      var annDefaultText = document.getElementById('ws-ann-default-text');
      if (annDefaultText) annDefaultText.style.display = 'none';
      var annDropshipText = document.getElementById('ws-ann-dropship-text');
      if (annDropshipText) annDropshipText.style.display = 'inline';
      var annDefault = document.getElementById('ws-announce-default');
      if (annDefault) annDefault.style.display = 'flex';
      var bannerNote = document.getElementById('ws-banner-note-text');
      if (bannerNote) bannerNote.textContent = 'Welcome to Smart Blonde Dropship!';
      var bannerInfoBtn = document.getElementById('ws-banner-info-btn');
      if (bannerInfoBtn) bannerInfoBtn.style.display = 'none';
      setTimeout(function() {
        var iconEl = Array.from(document.querySelectorAll('.icons-with-text__title')).find(function(el) {
          return el.textContent.includes('Bulk Order Discounts');
        });
        if (iconEl) iconEl.innerHTML = '<strong>Fast Fulfillment</strong>';
      }, 300);
      return;
    }

    document.querySelectorAll('a[href="/pages/shop-all-directory"]').forEach(function(el) {
      el.style.display = 'none';
    });
    setTimeout(function() {
      document.querySelectorAll('a[href="/pages/shop-all-directory"]').forEach(function(el) {
        el.style.display = 'none';
      });
    }, 500);

  // Click trap for blocked checkout buttons
    document.addEventListener('click', function(e) {
      if (e.target && e.target.id === 'ws-checkout-click-trap') {
        e.preventDefault();
        e.stopPropagation();
        showMinimumNotMetModal();
        return;
      }
      // Cart drawer and announcement bar blocked checkout
      var annBtn    = document.getElementById('ws-ann-checkout-btn');
      var drawerBtn = document.getElementById('cart-drawer-checkout-btn');
      var drawerWrap = document.querySelector('.cart-drawer__checkout-buttons');
      var clickedAnn    = annBtn    && (e.target === annBtn    || annBtn.contains(e.target));
      var clickedDrawer = drawerBtn && (e.target === drawerBtn || drawerBtn.contains(e.target));
      var clickedDrawerWrap = drawerWrap && (e.target === drawerWrap || drawerWrap.contains(e.target));

      if (clickedAnn) {
        e.preventDefault();
        e.stopPropagation();
        if (wholesaleEnabled) {
          var fetcher = nativeFetch || window.fetch.bind(window);
          fetcher('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              var wsTotal = 0;
              var skuTotals = getCustomSkuTotals(cart.items);
              cart.items.forEach(function(item) {
                var sku = (item.sku || '').toUpperCase();
                var wsPrice = null;
                if (sku.indexOf('CUSTOM') === 0 && window.wsCustomTiers && window.wsCustomTiers[sku]) {
                  var tiers = window.wsCustomTiers[sku];
                  var totalQty = skuTotals[sku] || item.quantity;
                  var keys = Object.keys(tiers).map(Number).sort(function(a,b){ return b-a; });
                  for (var i = 0; i < keys.length; i++) {
                    if (totalQty >= keys[i]) { wsPrice = Math.round(tiers[String(keys[i])] * 100); break; }
                  }
                }
                if (!wsPrice && item.properties && item.properties['_wholesale_price']) wsPrice = parseInt(item.properties['_wholesale_price'], 10);
                if (!wsPrice && window.wholesaleVariantPrices && window.wholesaleVariantPrices[String(item.variant_id)]) wsPrice = window.wholesaleVariantPrices[String(item.variant_id)].wholesale;
                wsTotal += (wsPrice || item.original_price) * item.quantity;
              });
              if (wsTotal < 15000) {
                showMinimumNotMetModal();
              } else {
                var href = annBtn.dataset.href;
                if (href) window.location.href = href;
              }
            });
        } else {
          var href = annBtn.dataset.href;
          if (href) window.location.href = href;
        }
        return;
      }

      if (clickedDrawer || clickedDrawerWrap) {
        if (wholesaleEnabled && lastWholesaleBlocked) {
          e.preventDefault();
          e.stopPropagation();
          showMinimumNotMetModal();
        }
      }
    });
  
  // Inject style to hide crossed-out retail prices in wholesale mode
    var wsStyle = document.createElement('style');
    wsStyle.id  = 'ws-price-hide-style';
    wsStyle.textContent = '';
    document.head.appendChild(wsStyle);

    function updatePriceHideStyle() {
      var style = document.getElementById('ws-price-hide-style');
      if (!style) return;
      style.textContent = wholesaleEnabled ? '.price__was:not(.ws-tier-was) { display:none !important; }' : '';
    }

    updatePriceHideStyle();
    document.addEventListener('wholesale:toggled', updatePriceHideStyle);

    // Position ws-cart-page-footer directly below cart-summary, matching its width
    function positionCartFooter() {
      var footer    = document.getElementById('ws-cart-page-footer');
      var summary   = document.getElementById('cart-summary');
      var container = document.querySelector('.container');
      if (!footer || !summary || !container) return;
      var summaryRect   = summary.getBoundingClientRect();
      var containerRect = container.getBoundingClientRect();
      var scrollTop     = window.pageYOffset || document.documentElement.scrollTop;
      footer.style.position = 'absolute';
      footer.style.top      = (summaryRect.bottom - containerRect.top + scrollTop) + 'px';
      footer.style.left     = (summaryRect.left - containerRect.left) + 'px';
      footer.style.width    = summaryRect.width + 'px';
      footer.style.zIndex   = '10';
      footer.style.display  = wholesaleEnabled ? 'block' : 'none';
    }

    positionCartFooter();
    window.addEventListener('resize', positionCartFooter);
    window.addEventListener('scroll', positionCartFooter);
    setInterval(positionCartFooter, 500);
    installCheckoutGuards();
    enforceCheckoutBlockUI();
    if (!checkoutGuardInterval) checkoutGuardInterval = setInterval(enforceCheckoutBlockUI, 500);

    // Keep cart minimum message outside and directly below cart summary
    attachMessageToSummary();
    window.addEventListener('resize', attachMessageToSummary);
    window.addEventListener('scroll', attachMessageToSummary, { passive: true });

    var retailBtn    = document.getElementById('ws-mode-retail');
    var wholesaleBtn = document.getElementById('ws-mode-wholesale');

    if (retailBtn) {
      retailBtn.addEventListener('click', function() {
        if (wholesaleEnabled) {
          if (window.wsCustomerWholesale) {
            showWholesaleLockedModal();
          } else {
            applyState(false);
            lastTierIndex = -1;
          }
        }
      });
    }

    if (wholesaleBtn) {
      wholesaleBtn.addEventListener('click', function() {
        if (wholesaleEnabled) {
          if (window.wsCustomerWholesale) {
            showWholesaleLockedModal();
          } else {
            applyState(false);
            lastTierIndex = -1;
          }
        } else {
          applyState(true);
          fireSparks(wholesaleBtn);
        }
      });
    }

    // Apply banner text on page load based on current state
    var bannerBtn = document.querySelector('.banner-btn-secondary');
    var bannerNote = document.getElementById('ws-banner-note-text');
    if (wholesaleEnabled) {
      if (bannerBtn) {
        bannerBtn._originalText = bannerBtn._originalText || bannerBtn.textContent;
        bannerBtn.textContent = 'See Wholesale Discount Tiers & Savings';
      }
      if (bannerNote) {
        bannerNote._originalText = bannerNote._originalText || bannerNote.textContent;
        bannerNote.textContent = 'Welcome to Smart Blonde Wholesale!';
        var bannerInfoBtn = document.getElementById('ws-banner-info-btn');
        if (bannerInfoBtn) bannerInfoBtn.style.display = 'none';
      }
    }

    // ── Wholesale Tiers Popup ─────────────────────────────────────────────
    // Build tiers popup shell (rows injected dynamically on open)
    var tiersPopupShell = '<div id="ws-tiers-popup-overlay" style="display:none;position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:99999;align-items:center;justify-content:center;"><div style="background:#fff;border:1px solid #f0f0f0;border-top:3px solid #f0c419;border-radius:16px;padding:24px 20px;max-width:520px;width:95%;position:relative;font-family:inherit;box-shadow:0 20px 60px rgba(0,0,0,0.15);"><button id="ws-tiers-popup-close" style="position:absolute;top:14px;right:16px;background:none;border:none;color:#bbb;font-size:22px;cursor:pointer;line-height:1;">✕</button><div style="text-align:center;margin-bottom:20px;"><img src=\"https://cdn.shopify.com/s/files/1/0861/1368/1687/files/SmartBlondeLogoTransparent_2.png?v=1719892102\" alt=\"Smart Blonde\" style=\"height:55px;width:auto;object-fit:contain;\"></div><h2 style="text-align:center;font-size:20px;font-weight:800;color:#1a1008;margin:0 0 4px;">Discount Tiers & Savings</h2><p style="text-align:center;font-size:13px;color:#888;margin:0 0 20px;">The more you order, the more you save.</p><div style="height:1px;background:#f0f0f0;margin-bottom:20px;"></div><div id="ws-tiers-popup-rows" style="display:flex;flex-direction:column;gap:8px;margin-bottom:20px;"></div><p style="text-align:center;font-size:13px;color:#555;font-weight:600;margin:0;line-height:1.6;letter-spacing:0.01em;">Discounts apply automatically at checkout.</p></div></div>';

    document.body.insertAdjacentHTML('beforeend', tiersPopupShell);

    var popupOverlay = document.getElementById('ws-tiers-popup-overlay');
    var popupClose   = document.getElementById('ws-tiers-popup-close');

    var TIER_DEFS = [
      { label: '$0 – $149',       min: 0,     discount: 'Locked',    perks: 'Min. $150 required', free: false, locked: true  },
      { label: '$150 – $299',     min: 150,   discount: 'Wholesale', perks: 'Base pricing',        free: false, locked: false },
      { label: '$300 – $599',     min: 300,   discount: '4% Off',    perks: '+ Wholesale',         free: false, locked: false },
      { label: '$600 – $1,199',   min: 600,   discount: '4% Off',    perks: '+ Free Shipping',     free: true,  locked: false },
      { label: '$1,200 – $4,999', min: 1200,  discount: '6% Off',    perks: '+ Free Shipping',     free: true,  locked: false },
      { label: '$5,000 – $11,999',min: 5000,  discount: '10% Off',   perks: '+ Free Shipping',     free: true,  locked: false },
      { label: '$12,000+',        min: 12000, discount: '12% Off',   perks: '+ Free Shipping',     free: true,  locked: false }
    ];

    function buildTierRows(currentDollars) {
      var rowsEl = document.getElementById('ws-tiers-popup-rows');
      if (!rowsEl) return;

      // Find current tier index
      var currentTierIndex = 0;
      for (var i = 0; i < TIER_DEFS.length; i++) {
        if (currentDollars >= TIER_DEFS[i].min) currentTierIndex = i;
      }

      var html = '<div style="display:grid;grid-template-columns:1.2fr 0.9fr 0.9fr;gap:4px;padding:4px 8px;">'
        + '<span style="font-size:9px;font-weight:700;color:#555;text-transform:uppercase;letter-spacing:0.05em;">Order Total</span>'
        + '<span style="font-size:9px;font-weight:700;color:#555;text-transform:uppercase;letter-spacing:0.05em;text-align:center;">Discount</span>'
        + '<span style="font-size:9px;font-weight:700;color:#555;text-transform:uppercase;letter-spacing:0.05em;text-align:right;">Perks</span>'
        + '</div>';

      TIER_DEFS.forEach(function(tier, idx) {
        var isActive = (idx === currentTierIndex) && wholesaleEnabled;
        var bg      = isActive ? 'background:linear-gradient(135deg,#fffbea,#fff9d6);border:1px solid rgba(240,196,25,0.6);' : 'background:#f9f9f9;border:1px solid #eeeeee;';
        var label1  = isActive ? 'color:#1a1008;font-weight:700;' : 'color:#888;';
        var label2  = tier.locked ? 'color:#ccc;font-style:italic;' : (isActive ? 'color:#1a1008;font-weight:800;' : 'color:#1a1008;font-weight:700;');
        var label3  = tier.free ? 'color:#16a34a;' : (tier.locked ? 'color:#ccc;' : 'color:#888;');
        var badge   = isActive ? '<br><span style="font-size:9px;font-weight:700;background:#f0c419;color:#000;border-radius:4px;padding:1px 5px;letter-spacing:0.05em;">YOU ARE HERE</span>' : '';

        html += '<div style="display:grid;grid-template-columns:1.2fr 0.9fr 0.9fr;gap:4px;' + bg + 'border-radius:8px;padding:8px;align-items:center;">'
          + '<span style="font-size:11px;' + label1 + '">' + tier.label + badge + '</span>'
          + '<span style="font-size:12px;text-align:center;white-space:nowrap;' + label2 + '">' + tier.discount + '</span>'
          + '<span style="font-size:11px;text-align:right;white-space:nowrap;' + label3 + '">' + tier.perks + '</span>'
          + '</div>';
      });

      rowsEl.innerHTML = html;
    }

    function openTiersPopup() {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var total = 0;
          var skuTotals = {};
          cart.items.forEach(function(item) {
            var sku = (item.sku || '').toUpperCase();
            if (sku.indexOf('CUSTOM') === 0) skuTotals[sku] = (skuTotals[sku] || 0) + item.quantity;
          });
          cart.items.forEach(function(item) {
            var sku = (item.sku || '').toUpperCase();
            var wsPrice = null;
            if (sku.indexOf('CUSTOM') === 0 && window.wsCustomTiers && window.wsCustomTiers[sku]) {
              var tiers = window.wsCustomTiers[sku];
              var totalQty = skuTotals[sku] || item.quantity;
              var keys = Object.keys(tiers).map(Number).sort(function(a, b) { return b - a; });
              for (var i = 0; i < keys.length; i++) {
                if (totalQty >= keys[i]) { wsPrice = Math.round(tiers[String(keys[i])] * 100); break; }
              }
            }
            if (!wsPrice && item.properties && item.properties['_wholesale_price']) wsPrice = parseInt(item.properties['_wholesale_price'], 10);
            if (!wsPrice && window.wholesaleVariantPrices && window.wholesaleVariantPrices[String(item.variant_id)]) wsPrice = window.wholesaleVariantPrices[String(item.variant_id)].wholesale;
            total += (wsPrice || item.original_price) * item.quantity;
          });
          buildTierRows(total / 100);
        })
        .catch(function() { buildTierRows(0); });
      popupOverlay.style.display = 'flex';
    }

    function closeTiersPopup() {
      popupOverlay.style.display = 'none';
    }

    // Close on X button
    if (popupClose) popupClose.addEventListener('click', closeTiersPopup);

    // Close on overlay click
    if (popupOverlay) {
      popupOverlay.addEventListener('click', function(e) {
        if (e.target === popupOverlay) closeTiersPopup();
      });
    }

    // Close on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeTiersPopup();
    });

    // Attach click to banner button when wholesale is on
    function attachTiersPopupToBanner() {
      var btn = document.querySelector('.banner-btn-secondary');
      if (!btn) return;
      if (btn._retailHandler) btn.removeEventListener('click', btn._retailHandler);
      if (btn._tiersHandler) btn.removeEventListener('click', btn._tiersHandler);
      if (wholesaleEnabled) {
        btn._originalHref = btn._originalHref || btn.getAttribute('href');
        btn.setAttribute('href', '#');
        btn._tiersHandler = function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          openTiersPopup();
        };
        btn.addEventListener('click', btn._tiersHandler);
      } else {
        if (btn._originalHref) btn.setAttribute('href', btn._originalHref);
        btn._retailHandler = function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          closeWsNavPopup();
          applyState(true);
          fireSparks(document.getElementById('ws-mode-wholesale'));
          showWsWelcomeToast();
        };
        btn.addEventListener('click', btn._retailHandler);
      }
    }

    attachTiersPopupToBanner();
    document.addEventListener('wholesale:toggled', function() {
      attachTiersPopupToBanner();
    });

    // ── Wholesale Nav Button Popup ────────────────────────────────────────
    var wsNavPopupHTML = [
      '<div id="ws-nav-popup-overlay" style="display:none;position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:99999;align-items:center;justify-content:center;">',
        '<div style="background:#fff;border:1px solid #f0f0f0;border-top:3px solid #f0c419;border-radius:16px;padding:32px 36px;max-width:440px;width:90%;position:relative;font-family:inherit;box-shadow:0 20px 60px rgba(0,0,0,0.15);">',

          // Close
          '<button id="ws-nav-popup-close" style="position:absolute;top:14px;right:16px;background:none;border:none;color:#bbb;font-size:20px;cursor:pointer;line-height:1;">✕</button>',

          // Logo
          '<div style="text-align:center;margin-bottom:20px;">',
            '<img src="https://cdn.shopify.com/s/files/1/0861/1368/1687/files/SmartBlondeLogoTransparent_2.png?v=1719892102" alt="Smart Blonde" style="height:60px;width:auto;object-fit:contain;">',
          '</div>',

          // Heading
          '<h2 style="text-align:center;font-size:20px;font-weight:800;color:#1a1008;margin:0 0 6px;">Wholesale Pricing</h2>',
          '<p style="text-align:center;font-size:13px;color:#888;margin:0 0 20px;">No account needed. Toggle on and save instantly.</p>',

          // Divider
          '<div style="height:1px;background:#f0f0f0;margin-bottom:20px;"></div>',

          // Three simple points
          '<div style="display:flex;flex-direction:column;gap:12px;margin-bottom:24px;">',

            '<div style="display:flex;align-items:center;gap:12px;">',
              '<span style="font-size:20px;">🏷️</span>',
              '<p style="margin:0;font-size:13px;color:#444;line-height:1.4;"><strong>Lower prices</strong> — wholesale rates applied across the entire store instantly.</p>',
            '</div>',

            '<div style="display:flex;align-items:center;gap:12px;">',
              '<span style="font-size:20px;">📦</span>',
              '<p style="margin:0;font-size:13px;color:#444;line-height:1.4;"><strong>$150 minimum</strong> — the more you order, the more you save. Up to <strong>12% off + free shipping.</strong></p>',
            '</div>',

            '<div style="display:flex;align-items:center;gap:12px;">',
              '<span style="font-size:20px;">✅</span>',
              '<p style="margin:0;font-size:13px;color:#444;line-height:1.4;"><strong>No account required</strong> — shop as a guest with wholesale pricing.</p>',
            '</div>',

          '</div>',

          // CTA
          '<button id="ws-nav-popup-enable" style="width:100%;padding:14px;background:linear-gradient(180deg,#f7cd30 0%,#e8b800 100%);color:#1a1000;font-size:14px;font-weight:800;border:2px solid #c49a00;border-radius:8px;cursor:pointer;letter-spacing:0.02em;">',
            'Enable Wholesale Pricing →',
          '</button>',

          '<p style="text-align:center;margin:10px 0 0;"><a id="ws-nav-popup-dismiss" href="#" style="font-size:12px;color:#bbb;text-decoration:none;">No thanks</a></p>',

        '</div>',
      '</div>'
    ].join('');

    document.body.insertAdjacentHTML('beforeend', wsNavPopupHTML);

    var wsNavOverlay = document.getElementById('ws-nav-popup-overlay');
    var wsNavClose   = document.getElementById('ws-nav-popup-close');
    var wsNavEnable  = document.getElementById('ws-nav-popup-enable');
    var wsNavDismiss = document.getElementById('ws-nav-popup-dismiss');

    function openWsNavPopup() {
      wsNavOverlay.style.display = 'flex';
    }
    function closeWsNavPopup() {
      wsNavOverlay.style.display = 'none';
    }

    // Close on X
    if (wsNavClose) wsNavClose.addEventListener('click', closeWsNavPopup);

    // Close on overlay click
    if (wsNavOverlay) {
      wsNavOverlay.addEventListener('click', function(e) {
        if (e.target === wsNavOverlay) closeWsNavPopup();
      });
    }

    // Close on Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeWsNavPopup();
    });

    // Enable wholesale and close
    if (wsNavEnable) {
      wsNavEnable.addEventListener('click', function() {
        if (!wholesaleEnabled) {
          applyState(true);
          fireSparks(document.getElementById('ws-mode-wholesale'));
        }
        closeWsNavPopup();
        showWsWelcomeToast();
      });
    }

    // ── Welcome Toast ─────────────────────────────────────────────────────
    function showWsWelcomeToast() {
      var existing = document.getElementById('ws-welcome-toast');
      if (existing) existing.remove();

      var toast = document.createElement('div');
      toast.id = 'ws-welcome-toast';
      toast.innerHTML = [
        '<div style="display:flex;align-items:center;gap:16px;">',
          '<img src="https://cdn.shopify.com/s/files/1/0861/1368/1687/files/SmartBlondeLogoTransparent_2.png?v=1719892102" alt="Smart Blonde" style="height:48px;width:auto;object-fit:contain;flex-shrink:0;">',
          '<div style="flex:1;min-width:0;">',
            '<p style="margin:0 0 3px;font-size:14px;font-weight:800;color:#1a1008;">Wholesale Pricing Enabled! 🎉</p>',
            '<p style="margin:0;font-size:12px;color:#555;line-height:1.5;">Your prices have been updated. Add <strong>$150+</strong> to unlock checkout and save up to <strong>12% off.</strong></p>',
          '</div>',
          '<button id="ws-toast-close" style="background:none;border:none;cursor:pointer;color:#bbb;font-size:18px;line-height:1;flex-shrink:0;padding:0;">✕</button>',
        '</div>'
      ].join('');

      toast.style.cssText = [
        'position:fixed',
        'bottom:24px',
        'left:50%',
        'transform:translateX(-50%) translateY(20px)',
        'background:#fff',
        'border:1px solid #f0f0f0',
        'border-top:3px solid #f0c419',
        'border-radius:16px',
        'padding:28px 32px',
        'max-width:440px',
        'width:90%',
        'z-index:9999999',
        'box-shadow:0 20px 60px rgba(0,0,0,0.15)',
        'opacity:0',
        'transition:opacity 0.4s ease, transform 0.4s ease',
        'margin:0'
      ].join(';');

      document.body.appendChild(toast);

      var closeBtn = document.getElementById('ws-toast-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function() {
          toast.style.opacity = '0';
          toast.style.transform = 'translate(-50%, -40%)';
          var ol = document.getElementById('ws-toast-overlay');
          if (ol) { ol.style.opacity = '0'; setTimeout(function() { ol.remove(); }, 400); }
          setTimeout(function() { toast.remove(); }, 400);
        });
      }

      setTimeout(function() {
        toast.style.opacity = '1';
        toast.style.transform = 'translateX(-50%) translateY(0)';
      }, 50);

      setTimeout(function() {
        if (!document.getElementById('ws-welcome-toast')) return;
        toast.style.opacity = '0';
        toast.style.transform = 'translateX(-50%) translateY(20px)';
        var ol = document.getElementById('ws-toast-overlay');
        if (ol) { ol.style.opacity = '0'; setTimeout(function() { ol.remove(); }, 400); }
        setTimeout(function() { toast.remove(); }, 400);
      }, 5000);
    }

    // Dismiss
    if (wsNavDismiss) {
      wsNavDismiss.addEventListener('click', function(e) {
        e.preventDefault();
        closeWsNavPopup();
      });
    }

    // Intercept the nav "Wholesale" link
    function interceptWholesaleNavLink() {
      document.querySelectorAll('a').forEach(function(link) {
        var text = link.textContent.trim().toLowerCase();
        var isWholesaleLink =
          text === 'wholesale' ||
          text === 'start a wholesale order here' ||
          text.includes('start a wholesale order');

        if (!isWholesaleLink) return;
        if (link.classList.contains('banner-btn-secondary')) return;

        if (link._wsHandler) link.removeEventListener('click', link._wsHandler);
        link._wsHandler = function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          closeWsNavPopup();
          if (!wholesaleEnabled) {
            applyState(true);
            fireSparks(document.getElementById('ws-mode-wholesale'));
            showWsWelcomeToast();
          }
        };
        link.addEventListener('click', link._wsHandler);
      });
    }
    interceptWholesaleNavLink();
    setTimeout(interceptWholesaleNavLink, 500);
    setTimeout(interceptWholesaleNavLink, 1500);
    setTimeout(interceptWholesaleNavLink, 3000);

    // ── Info button opens wholesale popup ─────────────────────────────────
    function attachInfoBtn() {
      var infoBtn = document.getElementById('ws-info-btn');
      if (infoBtn && !infoBtn._wsInfoAttached) {
        infoBtn._wsInfoAttached = true;
        infoBtn.addEventListener('click', function(e) {
          e.preventDefault();
          openWsNavPopup();
        });
        infoBtn.addEventListener('mouseenter', function() {
          infoBtn.style.color = '#f0c419';
        });
        infoBtn.addEventListener('mouseleave', function() {
          infoBtn.style.color = '#888';
        });
      }

      var bannerInfoBtn = document.getElementById('ws-banner-info-btn');
      if (bannerInfoBtn && !bannerInfoBtn._wsInfoAttached) {
        bannerInfoBtn._wsInfoAttached = true;
        bannerInfoBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          openWsNavPopup();
        });
        bannerInfoBtn.addEventListener('mouseenter', function() {
          bannerInfoBtn.style.background = '#f0c419';
          bannerInfoBtn.style.color = '#1a1008';
        });
        bannerInfoBtn.addEventListener('mouseleave', function() {
          bannerInfoBtn.style.background = '#1a1008';
          bannerInfoBtn.style.color = '#fff';
        });
      }
    }

    attachInfoBtn();
    setTimeout(attachInfoBtn, 300);
    setTimeout(attachInfoBtn, 800);
    setTimeout(attachInfoBtn, 1500);
    setTimeout(attachInfoBtn, 3000);

    function syncMobileToggle() {
      var mobileWrapper = document.getElementById('wholesale-toggle-wrapper-mobile');
      var mobileRetail = document.getElementById('ws-mode-retail-mobile');
      var mobileWholesale = document.getElementById('ws-mode-wholesale-mobile');
      var mobileInfo = document.getElementById('ws-info-btn-mobile');

      if (!mobileWrapper) return;

      if (wholesaleEnabled) {
        mobileWrapper.classList.add('is-wholesale');
        mobileWrapper.classList.remove('is-retail');
        if (mobileWholesale) mobileWholesale.classList.add('ws-mode-toggle__btn--active');
        if (mobileRetail) mobileRetail.classList.remove('ws-mode-toggle__btn--active');
      } else {
        mobileWrapper.classList.add('is-retail');
        mobileWrapper.classList.remove('is-wholesale');
        if (mobileRetail) mobileRetail.classList.add('ws-mode-toggle__btn--active');
        if (mobileWholesale) mobileWholesale.classList.remove('ws-mode-toggle__btn--active');
      }

      if (mobileRetail && !mobileRetail._wsAttached) {
        mobileRetail._wsAttached = true;
        mobileRetail.addEventListener('click', function() {
          if (wholesaleEnabled) {
            if (window.wsCustomerWholesale) {
              showWholesaleLockedModal();
            } else {
              applyState(false);
              lastTierIndex = -1;
            }
          }
        });
      }

      if (mobileWholesale && !mobileWholesale._wsAttached) {
        mobileWholesale._wsAttached = true;
        mobileWholesale.addEventListener('click', function() {
          if (wholesaleEnabled) {
            if (window.wsCustomerWholesale) {
              showWholesaleLockedModal();
            } else {
              applyState(false);
              lastTierIndex = -1;
            }
          } else {
            applyState(true);
            fireSparks(mobileWholesale);
          }
        });
      }

      if (mobileInfo && !mobileInfo._wsAttached) {
        mobileInfo._wsAttached = true;
        mobileInfo.addEventListener('click', function(e) {
          e.preventDefault();
          openWsNavPopup();
        });
      }
    }

    syncMobileToggle();
    setTimeout(syncMobileToggle, 300);
    document.addEventListener('wholesale:toggled', syncMobileToggle);

    function attachLearnMore() {
      var learnMore = document.getElementById('ws-ann-learn-more');
      if (!learnMore || learnMore._wsAttached) return;
      learnMore._wsAttached = true;
      learnMore.addEventListener('click', function(e) {
        e.preventDefault();
        openTiersPopup();
      });
    }
    attachLearnMore();
    setTimeout(attachLearnMore, 500);
    setTimeout(attachLearnMore, 1500);

    if (wholesaleEnabled) {
      setToggleUI(true);
      setAnnouncementProgress(true);
      swapPrices(true);
      applyTierPricesToCart();
      setTimeout(applyTierPricesToCart, 500);
      setTimeout(function() {
        document.querySelectorAll('a[href="/pages/smart-blonde-wholesale-info"]').forEach(function(el) {
          el.style.display = 'none';
        });
        var shippingEl = Array.from(document.querySelectorAll('.icons-with-text__title')).find(function(el) {
          return el.textContent.includes('Free Shipping');
        });
        if (shippingEl) {
          shippingEl._originalText = shippingEl._originalText || shippingEl.innerHTML;
          shippingEl.innerHTML = '<strong>Free Shipping Over $600</strong>';
        }
      }, 300);
      var bannerBtn = document.querySelector('.banner-btn-secondary');
      if (bannerBtn) {
        bannerBtn._originalText = bannerBtn._originalText || bannerBtn.textContent;
        bannerBtn.textContent = 'See Wholesale Discount Tiers & Savings';
        bannerBtn.classList.add('ws-active');
      }
      var bannerNote = document.getElementById('ws-banner-note-text');
      if (bannerNote) {
        bannerNote._originalText = bannerNote._originalText || bannerNote.textContent;
        bannerNote.textContent = 'Welcome to Smart Blonde Wholesale!';
      }
      var bannerInfoBtn = document.getElementById('ws-banner-info-btn');
      if (bannerInfoBtn) bannerInfoBtn.style.display = 'none';
    } else {
      setToggleUI(false);
      applyRetailPricesToVisibleCart();
    }

    updateCheckoutLink(wholesaleEnabled);
    observeDOM();
    installWholesaleProgressBarSync();

    document.addEventListener('variant:change',   handleVariantChange);
    document.addEventListener('variantChange',     handleVariantChange);
    document.addEventListener('on:variant:change', handleVariantChange);

    // Theme fires a plain change on input.js-option with no variant in the event
    document.addEventListener('change', function(e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.matches('.js-option, [name^="options"]')) handleVariantChange(e);
    });

    if (document.getElementById('cart-summary')) {
      function runCartPageUpdate() {
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var total = 0;
            cart.items.forEach(function(item) {
              var wsPrice = null;
              if (item.properties && item.properties['_wholesale_price']) {
                wsPrice = parseInt(item.properties['_wholesale_price'], 10);
              }
              if (!wsPrice && window.wholesaleVariantPrices && window.wholesaleVariantPrices[String(item.variant_id)]) {
                wsPrice = window.wholesaleVariantPrices[String(item.variant_id)].wholesale;
              }
              if (wholesaleEnabled) {
                total += (wsPrice || item.original_price) * item.quantity;
              } else {
                var regularPrice = getRegularPriceForVariant(item.variant_id);
                total += (regularPrice || item.original_price) * item.quantity;
              }

              if (wholesaleEnabled) {
                var unitPrice = wsPrice || item.original_price;
                var linePrice = unitPrice * item.quantity;
                var row = document.querySelector('.cart-item[data-variant-id="' + item.variant_id + '"]');
                if (row) {
                  row.querySelectorAll('.price__current').forEach(function(el) {
                    el.textContent = formatMoney(unitPrice);
                  });
                  var totalEl = row.querySelector('.cart-item__total .price__current');
                  if (totalEl) totalEl.textContent = formatMoney(linePrice);
                  row.querySelectorAll('.price__was').forEach(function(el) {
                    el.style.display = '';
                  });
                  row.querySelectorAll('.discount').forEach(function(el) {
                    var li = el.closest('li');
                    if (li) li.style.display = '';
                  });
                }
              }
            });
            updateMinimumEnforcement(total);
            updateCartPageSubtotal(total);
          });
      }

      document.addEventListener('cart:updated', function() {
        if (sessionStorage.getItem('wholesale_enabled') === 'true') {
          setTimeout(applyTierPricesToCart, 300);
        }
      });

      document.addEventListener('cart:refresh', function() {
        if (sessionStorage.getItem('wholesale_enabled') === 'true') {
          setTimeout(applyTierPricesToCart, 300);
        }
      });

      var cartPageObserver = new MutationObserver(function(mutations, obs) {
        var priceEl = document.querySelector('.cart-item[data-variant-id] .price__current');
        if (priceEl) {
          obs.disconnect();
          runCartPageUpdate();
        }
      });
      cartPageObserver.observe(document.body, { childList: true, subtree: true });

      runCartPageUpdate();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();